/*===============================================
* product.js
* ================================================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

            this.$featuredImage.attr('src', sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();

theme.Product.custom = {
    checkProductVariantsInCart: function(){
        $.getJSON('/cart.js', function (cart) {
            let arr_id = [],
                arr_qty =[];
            for (var j = 0; cart.items.length > j; j++) {
                arr_id.push(cart.items[j].id);
                arr_qty.push(cart.items[j].quantity);
            }

            $('.product__info-container .product-variant').each(function () {
                let product_variant = $(this),
                    product_variant_id = product_variant.data('variant-id') * 1;
                //check = $(product_variant).prev('button');

                if(product_variant.hasClass('active')){

                    if(arr_id.indexOf(product_variant_id) >= 0){
                        let count = arr_qty[arr_id.indexOf(product_variant_id)];
                        product_variant.data("qty", count);
                        $('.product__buy-button-container').find('.quantity__input').val(count);
                    }else{
                        product_variant.data("qty", 0);
                        let block = $('.product__info-container .product-add-container');
                        $(block).find('.product-content-add').removeClass('hide');
                        $(block).find('.product-content-count').addClass('hide').find('.product-count').text(0);
                    }
                }else{
                    if(arr_id.indexOf(product_variant_id) >= 0){
                        let count = arr_qty[arr_id.indexOf(product_variant_id)];
                        product_variant.data("qty", count);
                        $('.product__buy-button-container').find('.quantity__input').val(count);
                    }else{
                        product_variant.data("qty", 0);
                    }
                }
            });
        });
    }
};

/*===============================================
* meal-pack-products.js
* ================================================*/
theme.mealPackProducts = {

    mealPackTest: function() {
        $('.packs-or-program .btn-meals-pack-quiz').click(function(){
            let content = $(this).data('action');
            if(content == 'program'){
                $('.test-content').addClass('hide');
                $('.wm-360-buy-meals-pack').removeClass('hide');
                $('.packs-or-program').addClass('hide');
                $('.test-meal-pack').css('padding-bottom', '0px');
                $('.to-chose-category-wm360').removeClass('hide');
            }else{
                $('.wm-360-buy-meals-pack').addClass('hide');
                $('.test-content').removeClass('hide');
                $('.packs-or-program').addClass('hide');
                $('.test-meal-pack').css('padding-bottom', '56px');
            }
        });

        $('.quiz-go-back').click(function(el){
            $('html, body').animate({
                scrollTop: $(".meals-pack-goal-main-header").offset().top - 100
            }, 1000);
            let button = $(this)[0];
            if($(button).hasClass('to-chose-category-wm360')){
                $('.meals-program-on-collection .quiz-go-back').addClass('hide');
                $('.test-content').addClass('hide');
                $('.packs-or-program').removeClass('hide');
                $('.wm-360-buy-meals-pack').addClass('hide');
            }else if($(button).hasClass('to-chose-category')){
                $('.test-content').addClass('hide');
                $('.packs-or-program').removeClass('hide')
            }else if($(button).hasClass('to-gender')){
                $(button).addClass('hide').removeClass('to-gender');
                $('.test-content-activity').fadeOut("slow", function() {
                    $('.test-content-gender').fadeIn("slow");
                });
                $('.question-number div:first-child').removeClass('active');
                $('.test-content .question-text').text('Are you male or female?');
            }else if($(button).hasClass('to-activity')){
                $('.test-content-gender').css({'display': 'none'});
                $('.test-content-days').fadeOut("slow", function() {
                    $('.test-content-activity').fadeIn("fast");
                    $('.test-content-gender').css({'display': 'none'});
                    $('.test-content .question-text').text('What best describes your activity level?');
                    $(button).removeClass('to-activity').addClass('to-gender');
                    window.history.pushState("/products/", "Collection Meals Pack", "/collections/"+ $('.meals-pack-goal-main-header').data('collection'));
                });
                $('.question-number div:last-child').removeClass('active');
                $('.question-number div:nth-child(2)').removeClass('active');
                $('.meal-pack-products').fadeOut("slow");
                $('.btn-days').removeClass('active');
                $('.test-result').addClass('hide');
                $('.test-result-gender .icon').css({'display': 'none'});
            }
        });

        $('.btn-gender').click(function () {
            let content = $(this).data('gender');
            $('.question-content').data('gender', content);
            $('.test-content-gender').fadeOut("slow", function() {
                $('.test-content-activity').fadeIn("slow");
            });
            $('.question-number div:first-child').addClass('active');
            $('.test-content .question-text').text('What best describes your activity level?');
            $('.quiz-go-back').removeClass('hide').addClass('to-gender');
        });

        $('input[name="test-activity"]').click(function () {
            let content = $('input[name="test-activity"]:checked').val();
            $('.question-content').data('activity', content);
            $('.test-content-activity').fadeOut("slow", function () {
                $('.test-content-days').fadeIn("slow");
            });
            $('.question-number div:nth-child(2)').addClass('active');
            $('.test-content .question-text').html('How many days do you want us to <br>make your meals for?');
            $('button.quiz-go-back').removeClass('to-gender').addClass('to-activity');

            let gender = $('.question-content').data('gender');
            setMealPackPrices(gender, content);
        });

        function setMealPackPrices(gender, activity){
            let packs = meal_packs_test_answers[gender][activity];
            for(let i = 0; packs.length> i; i++){
                let text_key = Object.keys(packs[i])[0],
                    new_price = packs[i][text_key][0],
                    discount_type = packs[i][text_key][2],
                    regular_price = packs[i][text_key][3],
                    meals_count = packs[i][text_key][1];

                $($('.btn-days .meals-count')[i]).text(meals_count + " MEALS");
                $($('.btn-days .pack-price .price_old')[i]).text('$'+regular_price);
                $($('.btn-days .pack-price .subscription-price')[i]).text('$'+new_price);
                $($('.btn-days .meal-price span')[i]).text("$"+(new_price/meals_count).toFixed(2));

            }

            $('.btn-days .pack-price').each(function () {
                let block = $(this),
                    price_old = block.find('.price_old').text().slice(1),
                    subscription_price = block.find('.subscription-price').text().slice(1);

                if(price_old*1 == subscription_price*1){
                    block.find('.price_old').addClass('hide');
                }else{
                    block.find('.price_old').removeClass('hide');
                }
            })
        }
    },

    mealPackTestResult: function () {
        $('.test-meal-pack .btn-days').click(function () {
            $('.btn-days').removeClass('active');
            $('.question-number div:last-child').addClass('active');
            $(this).addClass('active');

            let gender = $('.question-content').data('gender'),
                activity = $('.question-content').data('activity'),
                days = $(this).data('days');

            showResult(gender, activity, days);
        });

        function showResult(gender, activity, days) {
            if(activity.indexOf('_') != -1){
                activity =  activity.replace('_', ' ');
            }
            $('.test-meal-pack').css('padding-bottom', '56px');
            let result_block = $('.test-result');
            result_block.find('.test-result-gender span').text(gender);
            result_block.find('.icon-dumbbell-'+gender).css({'display': 'block'});
            result_block.find('.test-result-activity span').text(activity);
            result_block.find('.test-result-days span').text(days);
            result_block.removeClass('hide');

            $('html, body').animate({
                scrollTop: result_block.offset().top
            }, 1000);
        }
    },

    mealPackChangeProduct: function (products) {

        createProductsVariants(products);

        let allergens_icons ={
                kc_al_gluten : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-wheat" viewBox="0 0 18 25"><path d="M14.955.066a.49.49 0 0 1 .18.67l-.583 1.01c.282.352.415.863.38 1.488-.041.741-.316 1.587-.775 2.381-.252.437-.54.826-.844 1.154.341-.085.673-.129.985-.129.594 0 1.075.165 1.393.47l1.22-.644a.493.493 0 0 1 .459.87l-1.27.67c.06.972-.816 2.172-2.289 3.023a6.56 6.56 0 0 1-.887.43 1 1 0 0 1 .177.14l1.219-.644a.49.49 0 1 1 .458.869l-1.267.67c.026.413-.119.875-.429 1.35-.405.62-1.067 1.215-1.861 1.674a7.07 7.07 0 0 1-.684.345.514.514 0 0 1 .068.057l1.22-.643a.49.49 0 1 1 .459.868l-1.27.671c.026.414-.119.875-.428 1.35-.406.62-1.067 1.215-1.862 1.674-.783.452-1.601.721-2.33.77l-.24.01c-.763 0-1.34-.272-1.624-.764a1.34 1.34 0 0 1-.15-.391l-2.547 4.388a.68.68 0 0 1-.427.305.675.675 0 0 1-.508-.081.68.68 0 0 1-.224-.935l2.486-4.156-.125.006c-1.189 0-2.084-1.566-2.084-3.641 0-1.7.601-3.059 1.472-3.494l-.054-1.434a.492.492 0 0 1 .983-.038l.052 1.377.085.027a6.412 6.412 0 0 1-.043-.76c0-1.703.602-3.061 1.473-3.496l-.054-1.432a.49.49 0 1 1 .982-.037l.052 1.376c.071.02.14.046.209.078a6.488 6.488 0 0 1-.07-.976c0-1.702.601-3.061 1.472-3.495l-.054-1.434a.491.491 0 1 1 .982-.037l.053 1.377c.662.191 1.199.89 1.486 1.88a6.26 6.26 0 0 1 .57-1.302c.762-1.319 1.834-2.195 2.775-2.284l.156-.007c.076 0 .15.005.221.016l.585-1.01a.491.491 0 0 1 .671-.18zM9.212 16.432c-.608 0-1.366.237-2.08.649-1.405.811-1.976 1.893-1.752 2.283.089.15.315.246.633.267l.142.005c.607 0 1.364-.236 2.078-.648.654-.377 1.211-.874 1.53-1.361.25-.383.334-.728.222-.922-.1-.173-.382-.273-.773-.273zm-6.177-3.74c-.45 0-1.101 1.036-1.101 2.659 0 1.623.651 2.658 1.1 2.658.45 0 1.102-1.035 1.102-2.658-.001-1.623-.653-2.658-1.101-2.658zm3.844 2.47l-.853 1.468a6.72 6.72 0 0 1 1.299-.745 1.26 1.26 0 0 1-.3-.35 1.378 1.378 0 0 1-.146-.372zm-1.803-.571l.012.111a6.84 6.84 0 0 1 .02 1.028l.645-1.08a1.278 1.278 0 0 1-.677-.06zm6.63-2.48c-.608 0-1.364.236-2.078.648-.654.377-1.212.874-1.53 1.36-.251.384-.334.729-.222.923.088.151.314.246.632.268l.142.004c.608 0 1.365-.236 2.079-.647.653-.378 1.21-.873 1.53-1.361.25-.384.334-.729.222-.922-.101-.174-.383-.273-.774-.273zM5.53 8.37c-.448 0-1.1 1.035-1.1 2.658 0 1.624.652 2.659 1.1 2.659.45 0 1.102-1.035 1.102-2.659 0-1.623-.653-2.658-1.102-2.658zm3.946 2.322l-.932 1.602a6.598 6.598 0 0 1 1.48-.815 1.309 1.309 0 0 1-.548-.787zm-1.932-.64l.018.12a6.927 6.927 0 0 1 .032 1.401l.856-1.432a1.34 1.34 0 0 1-.906-.09zm6.755-2.429c-.608 0-1.366.236-2.08.647-.653.378-1.21.874-1.53 1.361-.25.384-.333.73-.221.922.087.152.314.247.632.269l.142.004c.608 0 1.365-.236 2.079-.648 1.405-.812 1.976-1.894 1.752-2.282-.101-.174-.383-.273-.774-.273zM8.12 3.884c-.448 0-1.1 1.034-1.1 2.658 0 1.623.652 2.658 1.1 2.658.449 0 1.102-1.035 1.102-2.658S8.569 3.883 8.12 3.883zm2.03 3.512c-.029.24-.072.468-.127.684.085.003.17.028.25.075l.016.01c.08.052.144.12.19.197.163-.164.346-.322.542-.472a1.3 1.3 0 0 1-.488-.164 1.344 1.344 0 0 1-.382-.33zm3.328-5.174c-.505 0-1.404.631-2.078 1.8-.378.654-.613 1.363-.645 1.944-.026.458.075.798.269.91.412.238 1.5-.395 2.283-1.75.377-.655.612-1.364.644-1.945.025-.457-.075-.797-.27-.91a.394.394 0 0 0-.203-.049z"></path></svg>',
                kc_al_peanuts : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-peanuts" viewBox="0 0 25 20"><path d="M9.371 8.662a.683.683 0 0 1-.851.46 5.332 5.332 0 0 1-3.677-3.923.685.685 0 1 1 1.334-.305c.105.457.348 1.133.91 1.762a3.976 3.976 0 0 0 1.825 1.155c.362.108.567.49.459.851m8.747-.878a7.666 7.666 0 0 1-1.958 2.896 7.606 7.606 0 0 1-2.19 1.409.686.686 0 0 1-.535-1.261 6.237 6.237 0 0 0 1.8-1.154 6.323 6.323 0 0 0 1.605-2.377.683.683 0 1 1 1.278.487m4.258 3.61c-1.275 2.992-4.12 5.447-7.247 6.254-.974.252-2.435.436-3.883-.097-1.308-.483-2.366-1.623-2.696-2.904a3.136 3.136 0 0 1-.044-1.401l.002-.006a3.08 3.08 0 0 1 .713-1.394c.612-.705 1.473-1.031 2.385-1.378.3-.114.6-.228.894-.356a6.808 6.808 0 0 0 1.189-.639l.027-.018.052-.037c1.038-.74 1.675-1.787 2.373-3.03.53-.95 1.078-1.93 1.878-2.562.705-.556 1.445-.715 2.205-.464 1.12.368 2.172 1.607 2.555 3.012.432 1.578.285 3.409-.403 5.02M8.188 10.95c-.349.401-.616.84-.802 1.3-1.723-.633-3.215-1.715-4.246-3.096C2.01 7.63 1.48 5.105 1.912 3.276c.256-1.084 1.02-1.793 2.041-1.895 1.086-.112 2.095.493 2.576 1.534.103.222.194.45.284.678.2.5.406 1.016.725 1.5.76 1.154 1.895 1.848 2.992 2.52.602.368 1.181.723 1.67 1.135-.077.036-.157.073-.241.11-.276.118-.558.224-.838.331-1.03.391-2.096.795-2.933 1.76m15.91-4.936c-.504-1.85-1.89-3.439-3.446-3.95-.837-.278-2.124-.381-3.48.69-1.014.802-1.63 1.902-2.253 3.016-.483.862-.942 1.633-1.54 2.2-.64-.608-1.398-1.071-2.134-1.521-1.014-.622-1.973-1.209-2.565-2.11-.243-.365-.415-.796-.597-1.252-.1-.248-.198-.498-.311-.743C7.042.762 5.49-.147 3.815.02 2.21.183.972 1.31.58 2.963.058 5.179.672 8.126 2.043 9.97c1.225 1.64 2.999 2.91 5.043 3.625-.026.456.02.922.14 1.392.437 1.704 1.83 3.213 3.546 3.848a7.19 7.19 0 0 0 2.487.427c.718 0 1.46-.095 2.212-.29 3.522-.91 6.727-3.673 8.164-7.04.817-1.918.982-4.02.464-5.919"></path></svg>',
                kc_al_treenuts : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-treenuts" viewBox="0 0 20 24"><path d="M9.902 0c.292 0 .536.244.536.537v1.829c4.537.268 8.342 3.732 8.951 8.293.05.463-.097.926-.365 1.268-.22.268-.513.439-.83.512v4.902c0 2.513-1.853 4.757-4.61 5.586l-3.512 1.049c-.048.024-.097.024-.146.024H9.86a.274.274 0 0 1-.105-.024c-.756-.22-1.536-.464-2.317-.708l-1.22-.366c-2.755-.829-4.585-3.073-4.585-5.56 0-1.269.025-2.513.025-3.781v-1.098a1.557 1.557 0 0 1-.854-.512 1.512 1.512 0 0 1-.39-1.268c.61-4.561 4.415-8.024 8.951-8.293V.537c0-.293.244-.537.537-.537zm7.146 12.512H2.731v1.073c-.024 1.244-.024 2.513-.024 3.756 0 2 1.536 3.805 3.804 4.513l1.22.366c.732.219 1.439.439 2.17.658l3.342-1c2.293-.707 3.83-2.512 3.83-4.537h-.025v-4.829zM9.878 3.44c-4.22 0-7.83 3.17-8.415 7.366a.523.523 0 0 0 .122.415c.097.121.244.17.39.17H17.78c.17 0 .292-.049.39-.17a.556.556 0 0 0 .122-.44c-.561-4.17-4.17-7.341-8.415-7.341zm4.243 6.122a.56.56 0 1 1 0 1.122.56.56 0 0 1 0-1.122zm1.854-2.049a.56.56 0 1 1-.001 0zm-3.146-.927a.56.56 0 1 1-.001 0z"></path></svg>',
                kc_al_eggs : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-egg" viewBox="0 0 19 24"><path d="M6.062 8.608a16.231 16.231 0 0 0-1.023 5.605.68.68 0 1 1-1.359 0c0-2.028.384-4.13 1.108-6.078a.679.679 0 1 1 1.273.473m2.021-3.68c-.32.406-.622.848-.897 1.313a.68.68 0 0 1-1.17-.691c.306-.518.643-1.01 1.002-1.464a.677.677 0 0 1 .953-.112.677.677 0 0 1 .112.954m1.731 17.714c-4.639 0-7.757-3.724-7.757-9.264 0-6.178 3.77-12.02 7.757-12.02 3.989 0 7.758 5.842 7.758 12.02 0 5.54-3.117 9.264-7.758 9.264M9.813 0C4.597 0 .7 7.063.7 13.378.699 19.632 4.446 24 9.813 24c5.369 0 9.116-4.368 9.116-10.622C18.929 7.063 15.03 0 9.813 0"></path></svg>',
                kc_al_dairy : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-milk" viewBox="0 0 18 24"><path d="M14.811 22.642H9.968V10.229h6.373v10.883c0 .843-.687 1.53-1.53 1.53zm-12.574-1.53V10.23h6.371v12.413H3.767c-.844 0-1.53-.687-1.53-1.53zM5.778 4.638h6.08L8.933 8.87h-6.08l2.925-4.232zm.325-1.36h6.373v-1.92H6.103v1.92zm9.622 5.592h-5.141l2.57-3.717 2.57 3.717zm1.974.59a.496.496 0 0 0-.084-.243l-3.78-5.471V.679A.68.68 0 0 0 13.154 0H5.423a.68.68 0 0 0-.68.68v3.066L1 9.163c-.01.014-.008.032-.016.045a.663.663 0 0 0-.087.252c-.003.022-.012.043-.013.065 0 .008-.006.016-.006.025v11.562A2.89 2.89 0 0 0 3.767 24H14.81a2.891 2.891 0 0 0 2.888-2.888V9.46z"></path></svg>',
                kc_al_sesame : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sesame" viewBox="0 0 21 24"><path d="M6.067 14.711a.479.479 0 0 1 .424 0c.033.017.819.412 1.594 1.343.707.848 1.55 2.33 1.55 4.57 0 1.295-.336 2.19-1.025 2.735-.694.55-1.61.62-2.331.62-.72 0-1.637-.07-2.332-.62-.689-.546-1.024-1.44-1.024-2.735 0-2.24.843-3.722 1.55-4.57.775-.93 1.56-1.326 1.594-1.343zm.212.984a4.99 4.99 0 0 0-1.1 1.005c-.863 1.053-1.3 2.373-1.3 3.924 0 .984.216 1.633.661 1.986.362.286.898.414 1.739.414.84 0 1.377-.128 1.739-.414.445-.353.661-1.002.661-1.986 0-1.55-.437-2.87-1.3-3.924a4.99 4.99 0 0 0-1.1-1.005zm5.718-4.088c.035-.012.87-.288 2.077-.178 1.1.1 2.743.553 4.327 2.136.915.916 1.311 1.785 1.21 2.658-.103.88-.7 1.578-1.21 2.088-.51.509-1.208 1.107-2.087 1.21-.09.01-.178.015-.267.015-.784 0-1.57-.403-2.392-1.225-1.583-1.584-2.035-3.228-2.135-4.328-.11-1.206.165-2.041.177-2.076a.48.48 0 0 1 .3-.3zm5.728 2.633c-2.18-2.179-4.452-1.94-5.182-1.788-.06.29-.134.823-.068 1.49.135 1.354.76 2.597 1.856 3.693.695.696 1.308 1.002 1.872.937.458-.054.928-.343 1.522-.937.594-.594.883-1.064.937-1.522.065-.564-.241-1.177-.937-1.873zm-1.002 2.384a.478.478 0 0 1 .675.676c-.212.212-.541.508-.952.635a.478.478 0 0 1-.281-.913c.158-.049.335-.175.558-.398zm-2.1 0a.48.48 0 0 1 .676 0c.027.028.054.054.08.078a.477.477 0 1 1-.648.702l-.108-.104a.48.48 0 0 1 0-.676zM4.108 5.104c2.24 0 3.72.843 4.57 1.55.93.775 1.326 1.561 1.342 1.594a.472.472 0 0 1 0 .424c-.016.033-.412.82-1.342 1.594-.85.707-2.33 1.55-4.57 1.55-1.295 0-2.19-.335-2.736-1.024-.55-.695-.62-1.611-.62-2.332 0-.72.07-1.637.62-2.331.546-.69 1.44-1.024 2.736-1.024zm0 .956c-.984 0-1.634.216-1.986.662-.287.361-.414.898-.414 1.738s.127 1.377.414 1.739c.352.445 1.002.661 1.986.661 1.55 0 2.87-.437 3.924-1.3a5.004 5.004 0 0 0 1.004-1.1 5.027 5.027 0 0 0-1.004-1.1c-1.054-.863-2.374-1.3-3.924-1.3zM15.576.016c.873-.102 1.742.294 2.658 1.21 1.583 1.583 2.035 3.227 2.136 4.327.11 1.206-.166 2.041-.178 2.076a.48.48 0 0 1-.3.3c-.03.01-.616.203-1.51.203-.177 0-.367-.007-.566-.025-1.1-.1-2.744-.553-4.328-2.136-.915-.916-1.311-1.785-1.21-2.658.103-.88.7-1.578 1.21-2.087.51-.51 1.208-1.108 2.088-1.21zm.26.94c-.05 0-.1.003-.15.009-.458.053-.928.342-1.522.936-.594.594-.883 1.064-.937 1.522-.065.564.241 1.177.937 1.873 1.096 1.096 2.339 1.72 3.693 1.855a5.04 5.04 0 0 0 1.49-.068c.059-.29.133-.823.067-1.488-.135-1.355-.76-2.598-1.856-3.694-.634-.634-1.2-.945-1.722-.945z"></path></svg>',
                kc_al_soy : '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-soy" viewBox="0 0 25 24"><path d="M17.742 0l.252.002c1.522.032 4.374.935 4.868 1.095l.07.022a.547.547 0 0 1 .347.347c.045.135 1.084 3.306 1.118 4.941a6.553 6.553 0 0 1-4.275 6.275c-.727.27-1.313.868-1.61 1.644a6.557 6.557 0 0 1-3.788 3.789c-.775.295-1.374.881-1.643 1.608A6.556 6.556 0 0 1 6.943 24c-.047 0-.092 0-.14-.002-1.636-.034-4.794-1.085-4.927-1.13a.548.548 0 0 1-.346-.344C1.486 22.39.434 19.23.4 17.594a6.554 6.554 0 0 1 4.275-6.275c.728-.27 1.314-.869 1.61-1.644a6.564 6.564 0 0 1 3.788-3.79c.776-.295 1.374-.88 1.644-1.608.97-2.616 3.494-4.348 6.277-4.275zm.228 1.092c-2.3-.07-4.422 1.384-5.23 3.564-.379 1.022-1.21 1.841-2.28 2.249a5.472 5.472 0 0 0-3.157 3.158c-.407 1.07-1.227 1.9-2.249 2.278a5.464 5.464 0 0 0-3.564 5.23c.026 1.221.742 3.566.99 4.347.781.249 3.126.964 4.347.99 2.324.077 4.422-1.383 5.23-3.564.379-1.022 1.21-1.842 2.28-2.25a5.467 5.467 0 0 0 3.157-3.157c.407-1.07 1.227-1.9 2.249-2.278a5.463 5.463 0 0 0 3.563-5.23c-.025-1.221-.732-3.572-.979-4.358-.786-.247-3.136-.953-4.357-.979zM6.944 14.182a3.276 3.276 0 0 1 3.273 3.272 3.276 3.276 0 0 1-3.273 3.273 3.276 3.276 0 0 1-3.273-3.273 3.276 3.276 0 0 1 3.273-3.272zm0 1.09c-1.203 0-2.182.98-2.182 2.182 0 1.204.98 2.182 2.182 2.182a2.184 2.184 0 0 0 2.182-2.182c0-1.203-.98-2.181-2.182-2.181zm5.454-6.545A3.276 3.276 0 0 1 15.671 12a3.276 3.276 0 0 1-3.273 3.273A3.276 3.276 0 0 1 9.126 12a3.276 3.276 0 0 1 3.272-3.273zm0 1.091A2.184 2.184 0 0 0 10.217 12c0 1.203.979 2.182 2.181 2.182A2.185 2.185 0 0 0 14.58 12a2.185 2.185 0 0 0-2.182-2.182zm5.455-6.545a3.276 3.276 0 0 1 3.273 3.272 3.276 3.276 0 0 1-3.273 3.273 3.276 3.276 0 0 1-3.273-3.273 3.276 3.276 0 0 1 3.273-3.272zm0 1.09a2.185 2.185 0 0 0-2.182 2.182c0 1.204.98 2.182 2.182 2.182a2.184 2.184 0 0 0 2.182-2.182c0-1.203-.98-2.181-2.182-2.181z"></path></svg>'
            },
            product_types ={
                wm_black_label : 'Black Label',
                wm_low_carb : 'Low Carb',
                wm_breakfast : 'Breakfast',
                wm_clean_meals : 'Clean',
                wm_clean_vegan : 'Vegan',
            };

        function createProductsVariants(products){
            let all_products_variants = [];
            for (let i = 0; products.length> i; i++){
                let product = products[i],
                    product_v_img = product.images[0],
                    product_v_title = product.title,
                    product_v_allergens = [],
                    discount_type = $('.days-meal-plan.meal-pack-has-discount').data('discount-type'),
                    discount_value = $('.days-meal-plan.meal-pack-has-discount').data('discount')*1,
                    product_variant_price;

                for(let k=0; product.tags.length > k; k++){
                    if(product.tags[k].indexOf('kc_al_') != -1 ){
                        product_v_allergens.push(product.tags[k]);
                    }
                }

                for (let j = 0; product.variants.length > j; j++) {
                    let product_v_size = '';
                    if(product.variants[j].title != 'Default Title'){
                        product_v_size += product.variants[j].title;
                    }

                    if(discount_type == "PERCENT" && discount_value > 0){
                        product_variant_price = (product.variants[j].price*1 - (product.variants[j].price*discount_value/100)).toFixed(2);
                    }else{
                        product_variant_price = product.variants[j].price;
                    }

                    let product_v_obj = {
                        'product_v_img': product_v_img,
                        'product_v_title': product_v_title,
                        'product_v_size': product_v_size,
                        'product_v_id': product.variants[j].apiId,
                        'product_v_price': product_variant_price,
                        'product_v_regular_price': product.variants[j].price,
                        'product_v_nutritions': product.variants[j].nutritions,
                        'product_v_calories': product.variants[j].nutritions.Calories,
                        'product_v_weight': product.variants[j].totalWeight,
                        'product_v_tags': product.tags,
                        'product_v_allergens': product_v_allergens
                    };

                    all_products_variants.push(product_v_obj);
                }
            }

            compareProductsCalories(all_products_variants);
            addProductsToEmpty(all_products_variants);
        }

        function compareProductsCaloriesProcess(products, button) {
            $('.pop-up-change-meal-tabs span').removeClass('active');
            $('.pop-up-change-meal-tabs span:first-child').addClass('active');
            $('.pop-up-change-meal h3').addClass('hide');
            $('.collection-meals-block').empty();
            $('.pop-up-change-meal').addClass('change-meal');
            $('body').addClass('active-pop-up');
            $('.meal').removeClass('product-to-change');
            button.parent().parent().addClass('product-to-change');

            let calories_max =  button.data('find-calories')*1 + 50,
                calories_min =  button.data('find-calories')*1 - 50,
                meal_number =  button.data('meal-number'),
                products_for_pop_up = [],
                meal_block =  button.parent().parent(),
                special_meal = meal_block.data('special'),
                first_price = meal_block.attr('data-variant-price'),
                meal_changed_price = meal_block.attr('data-variant-price_discount');

            $('.pop-up-change-meal').attr('data-change-price', first_price);
            $('.pop-up-change-meal').attr('data-variant-price_discount', meal_changed_price);
            $('.pop-up-change-meal').removeClass('new-meal special-meal');

            if(special_meal){
                setProductsInPopUp(products, meal_number, special_meal, first_price, meal_changed_price);
            }else {
                if(! $('.checkbox-all-meals input').prop('checked')){
                    for(let i = 0; products.length>i; i++ ){
                        if( products[i].product_v_calories > calories_min && products[i].product_v_calories < calories_max ){
                            products_for_pop_up.push(products[i]);
                        }
                    }
                }else{
                    products_for_pop_up = products;
                }
                setProductsInPopUp(products_for_pop_up, meal_number, special_meal, first_price, meal_changed_price);
            }
        }

        function compareProductsCalories(products){
            $('.meal-pack-page').on('click', '.change-meal', function () {
                let button = $(this);
                compareProductsCaloriesProcess(products, button);

                $('.checkbox-all-meals input').change(function () {
                    compareProductsCaloriesProcess(products, button);
                });

            })
        }

        function setProductsInPopUp(all_products, meal_number, special_meal, first_price, meal_changed_price) {
            let products = all_products.filter(function (product){
                return product.product_v_tags.indexOf('technical-product') == -1
            });

            if(special_meal){
                let products_set = [];
                for(let i = 0; products.length>i; i++){
                    if(products[i].product_v_tags.indexOf(special_meal) != -1){
                        products_set.push(products[i]);
                    }
                }
                for(let i = 0; products_set.length>i; i++){
                    createProductBlock(products_set[i], first_price, meal_changed_price);
                }
                $('.pop-up-change-meal').addClass('special-meal');
                $('.pop-up-change-meal-tabs').addClass('hide');
                $('.pop-up-change-meal .checkbox-all-meals').addClass('hide');
                $('.pop-up-change-meal h2').text('SELECT A '+special_meal);
            }else{
                $('.pop-up-change-meal-tabs').removeClass('hide');
                if(!$('.pop-up-change-meal').hasClass('new-meal')){
                    $('.pop-up-change-meal .checkbox-all-meals').removeClass('hide');
                }else{
                    $('.pop-up-change-meal .checkbox-all-meals').addClass('hide');
                }
                popUpFiltering(products);
                for(let i = 0; products.length>i; i++){
                    createProductBlock(products[i], first_price, meal_changed_price);
                }
                $('.pop-up-change-meal h2').text('SELECT A MEAL FOR Meal '+meal_number);
            }

            $('.pop-up-change-meal').removeClass('hide');


            $('.collection-meals-block').scrollTop(0);
        }

        function popUpFiltering(all_products){
            let meal_changed_price = $('.change-meal').attr('data-variant-price_discount')*1;
            $('.change-meal .pop-up-change-meal-tabs option.special-tag').attr('disabled','true');

            $('.pop-up-change-meal-tabs span').click(function () {
                $('.pop-up-change-meal h3').addClass('hide');
                $('.pop-up-change-meal-tabs span').removeClass('active');
                $('.collection-meals-block').empty();
                $(this).addClass('active');
                let tag = $(this).data('tag'),
                    first_price = $('.pop-up-change-meal').attr('data-change-price');
                filteringProducts(all_products, tag, first_price, meal_changed_price)
            });

            $('select.pop-up-change-meal-tabs').change(function () {
                $('.pop-up-change-meal h3').addClass('hide');
                $('.collection-meals-block').empty();
                let tag = $('select.pop-up-change-meal-tabs').val(),
                    first_price = $('.pop-up-change-meal').attr('data-change-price');
                filteringProducts(all_products, tag, first_price, meal_changed_price);
            });
        }

        function filteringProducts(all_products, tag, first_price, meal_changed_price){
            let products_with_tag = [];
            if(tag == 'all'){
                products_with_tag = all_products.slice(0);
            }else{
                for(let i = 0; all_products.length>i; i++){
                    let product = all_products[i];
                    if(product.product_v_tags.indexOf(tag) != -1){
                        products_with_tag.push(product);
                    }
                }
            }

            if(products_with_tag.length == 0 ){
                $('.pop-up-change-meal h3').removeClass('hide');
            }else{
                $('.pop-up-change-meal h3').addClass('hide');
                for(let i = 0; products_with_tag.length>i; i++){
                    createProductBlock(products_with_tag[i], first_price, meal_changed_price);
                }
            }
        }

        function createProductBlock(product, first_price, meal_changed_price) {
            let image_product = createSmallImage(product.product_v_img),
                allergens_block = '',
                block_price,
                product_type,
                product_d_price = product.product_v_price,
                data_discount = $('.meal-pack-has-discount').attr('data-discount'),
                units = 'g';

            if(product.product_v_tags.indexOf('juice') != -1) {
                units = 'ml';
            }

            if(product.product_v_tags.indexOf('wm_black_label') != -1){
                product_type = product_types.wm_black_label;
            }else if(product.product_v_tags.indexOf('wm_low_carb') != -1){
                product_type = product_types.wm_low_carb;
            }else if(product.product_v_tags.indexOf('wm_breakfast') != -1){
                product_type = product_types.wm_breakfast;
            }else if(product.product_v_tags.indexOf('wm_clean_meals') != -1){
                product_type = product_types.wm_clean_meals;
            }else if(product.product_v_tags.indexOf('wm_clean_vegan') != -1){
                product_type = product_types.wm_clean_vegan;
            }else if(product.product_v_tags.indexOf('snack') != -1){
                product_type = 'Snack';
            }else if(product.product_v_tags.indexOf('juice') != -1){
                product_type = 'Juice';
            }else{
                product_type = 'All';
            }

            if(meal_changed_price > 0){

                product_d_price = Math.round ((product.product_v_regular_price - (product.product_v_regular_price * data_discount/100))*100)/100;
                if(product_d_price){
                    block_price = Math.round ((meal_changed_price - product_d_price)*100)/100;
                }else{
                    block_price = Math.round ((meal_changed_price - product.product_v_regular_price)*100)/100;
                }

                if(block_price == 0){
                    block_price = 'same price';
                }else{
                    block_price > 0 ? block_price = '- $'+roundPrice(block_price) : block_price = '+ $'+roundPrice(block_price*(-1));
                }
            }else if(first_price > 0){
                block_price = Math.round ((first_price - product.product_v_price)*100)/100;
                if(block_price == 0){
                    block_price = 'same price';
                }else{
                    block_price > 0 ? block_price = '- $'+roundPrice(block_price) : block_price = '+ $'+roundPrice(block_price*(-1));
                }
            }else{
                block_price = '$'+ roundPrice(product.product_v_price);
            }

            for(let i=0; product.product_v_allergens.length>i; i++){
                let key = product.product_v_allergens[i];
                allergens_block += allergens_icons[key];
            }

            let product_block_nutrition = '<p><span class="to-day-protein">'+ product.product_v_nutritions.Protein +'</span>Protein (g)</p>\n' +
                    '<p><span class="to-day-cal">'+ product.product_v_nutritions.Calories +'</span>Calories</p>\n' +
                    '<p><span class="to-day-carbs">'+ product.product_v_nutritions.Carbohydrate +'</span>Carbs (g)</p>\n' +
                    '<p><span class="to-day-fat">'+ product.product_v_nutritions.Fat_Total +'</span>Fat (g)</p>',

                product_block = '<div>' +
                    '<div><img '+image_product+' alt="'+ product.product_v_title +' Workout Meals ™">' +
                    '<p class="product-type">'+ product_type +'</p><div class="short-info"><p><span>'+ product.product_v_size +' </span>' +
                    '<span> '+ product.product_v_weight +' ('+ units +')</span></p><p>'+ allergens_block +'</p></div></div>' +
                    '<div><p class="title">' + product.product_v_title + '</p>' +
                    '<div class="meal-nutrition">'+ product_block_nutrition +'</div>' +
                    '<div class="select_button"><p>'+ block_price +'</p><button data-id="'+product.product_v_id+'" data-price="'+product_d_price+'" data-regular-price="'+product.product_v_regular_price+'">Select</button></div></div></div>';

            $('.collection-meals-block').append(product_block);
        }

        function roundPrice(price){
            let new_price = (price*1).toFixed(2);
            return new_price;
        }

        $('.collection-meals-block').on('click', 'button', function () {
            let main_pack_block = $(".meal-pack-page").find(".days-meal-plan"),
                discount_type = $(main_pack_block).data("discount-type"),
                discount_p = $(main_pack_block).data("discount")*1;

            let button = $(this),
                variant_id = button.data('id'),
                content_block = button.parent().parent(),
                full_block = button.parent().parent().parent(),
                variant_img = full_block.find('img').attr('srcset'),
                variant_title = content_block.find('.title').text(),
                nutrition = content_block.find('.meal-nutrition').contents().clone(),
                product_to_change = $('.meal').filter('.product-to-change'),
                old_price = product_to_change.attr('data-variant-price')*1,
                old_d_price = product_to_change.attr('data-variant-price_discount')*1,
                variant_price = button.attr('data-regular-price')*1,
                variant_price_new = button.attr('data-price')*1,
                old_sum = $('.meal-pack-page .add-to-cart-plan .new-pack-sum').text()*1,
                old_sum_old = $('.meal-pack-page .add-to-cart-plan .old-pack-sum').text()*1,
                day_nutrition = product_to_change.parent().prev('.day-nutrition'),
                cal_for_filter = product_to_change.find('.change-meal'),

                day_nutrition_protein = day_nutrition.find('.day-protein').text()*1,
                day_nutrition_fat = day_nutrition.find('.day-fat').text()*1,
                day_nutrition_carbs = day_nutrition.find('.day-carbs').text()*1,
                day_nutrition_cal = day_nutrition.find('.day-cal').text()*1,

                old_protein = product_to_change.find('.to-day-protein').text() *1,
                old_fat = product_to_change.find('.to-day-fat').text() *1,
                old_carbs = product_to_change.find('.to-day-carbs').text() *1,
                old_cal = product_to_change.find('.to-day-cal').text() *1,
                new_protein = nutrition.find('.to-day-protein').text() *1,
                new_fat = nutrition.find('.to-day-fat').text()*1,
                new_carbs = nutrition.find('.to-day-carbs').text()*1,
                new_cal = nutrition.find('.to-day-cal').text()*1;

            if(!old_d_price){
                old_d_price = 0;
            }

            if(!variant_price_new){
                variant_price_new = variant_price;
            }

            $(product_to_change).attr('data-variant-price_discount', variant_price_new);

            let full_protein = Math.round((day_nutrition_protein - old_protein + new_protein)*100)/100,
                full_fat = Math.round((day_nutrition_fat - old_fat + new_fat)*100)/100,
                full_carbs = Math.round((day_nutrition_carbs - old_carbs + new_carbs)*100)/100,
                full_cal = Math.round((day_nutrition_cal - old_cal + new_cal)*100)/100,
                full_new_price = Math.round((old_sum - old_d_price + variant_price_new)*100)/100,
                full_new_price_old = Math.round((old_sum_old - old_price + variant_price)*100)/100;

            day_nutrition.find('.day-protein').text(full_protein);
            day_nutrition.find('.day-fat').text(full_fat);
            day_nutrition.find('.day-carbs').text(full_carbs);
            day_nutrition.find('.day-cal').text(full_cal);
            $('.meal-pack-page .add-to-cart-plan .old-pack-sum').text(full_new_price_old);
            $('.meal-pack-page .add-to-cart-plan .new-pack-sum').text(full_new_price);

            product_to_change.find('.meal-title').text(variant_title);
            product_to_change.attr('data-variant', variant_id);
            $(product_to_change).attr('data-variant-price', variant_price);
            product_to_change.find('.meal-image').html('<img  srcset="' + variant_img + '" alt="'+ variant_title +'">');
            product_to_change.find('.meal-nutrition').html(nutrition);
            cal_for_filter.attr('data-find-calories', new_cal);

            if(product_to_change.hasClass('empty-meal')){
                product_to_change.find('.change-meal').removeClass('hide');
                product_to_change.find('.delete-meal').removeClass('hide');
                product_to_change.find('.meal-image').addClass('full-product');
                product_to_change.removeClass('empty-meal');
            }

            $('.pop-up-change-meal').addClass('hide').attr('data-change-price', '');
            $('body').removeClass('active-pop-up');
            $('.collection-meals-block').empty();
        });

        function createSmallImage(image){
            if(image){
                let img_small = image.replace('.jpg','_260x.jpg'),
                    img_medium = image.replace('.jpg','_390x.jpg'),
                    img_large = image.replace('.jpg','_520x.jpg'),
                    full_img = 'srcset="'+ img_small +', '+ img_medium +' 1.5x, '+ img_large +' 2x" ' +
                        'src="'+ img_small +'"';
                return full_img;
            }
        }

        $('.meal-pack-page').on('click','.delete-meal', function () {
            let main_pack_block = $(".meal-pack-page").find(".days-meal-plan"),
                discount_type = $(main_pack_block).data("discount-type"),
                discount_p = $(main_pack_block).data("discount")*1;

            let product = $(this).parent().parent(),
                product_price = $(product).attr('data-variant-price')*1,
                product_price_discount =  $(product).attr('data-variant-price_discount')*1,
                variant_title = 'Choose a '+ product.find('.meal-number').text(),
                nutrition = '<p><span class="to-day-protein">0</span>Protein (g)</p>\n' +
                    '<p><span class="to-day-cal">0</span>Calories</p>\n' +
                    '<p><span class="to-day-carbs">0</span>Carbs (g)</p>\n' +
                    '<p><span class="to-day-fat">0</span>Fat (g)</p>',
                old_sum = $('.meal-pack-page .add-to-cart-plan .new-pack-sum').text()*1,
                old_full_price_old = $('.meal-pack-page .add-to-cart-plan .old-pack-sum').text()*1,
                day_nutrition = product.parent().prev('.day-nutrition'),
                day_nutrition_protein = day_nutrition.find('.day-protein').text()*1,
                day_nutrition_fat = day_nutrition.find('.day-fat').text()*1,
                day_nutrition_carbs = day_nutrition.find('.day-carbs').text()*1,
                day_nutrition_cal = day_nutrition.find('.day-cal').text()*1,

                old_protein = product.find('.to-day-protein').text() *1,
                old_fat = product.find('.to-day-fat').text() *1,
                old_carbs = product.find('.to-day-carbs').text() *1,
                old_cal = product.find('.to-day-cal').text() *1;

            let full_protein = Math.round((day_nutrition_protein - old_protein)*100)/100,
                full_fat = Math.round((day_nutrition_fat - old_fat)*100)/100,
                full_carbs = Math.round((day_nutrition_carbs - old_carbs)*100)/100,
                full_cal = Math.round((day_nutrition_cal - old_cal)*100)/100,
                full_new_price,
                old_full_price = Math.round((old_full_price_old - product_price)*100)/100;

            /*if(discount_type == "FIXED"){
                      console.log('product');
                      console.log(product_price);
                      full_new_price = Math.round((old_sum - product_price)*100)/100;

                  }else{
                      console.log('new sum');
                      let p_product_price = (product_price - (product_price*discount_p/100)).toFixed(2);
                      full_new_price = Math.round((old_sum - p_product_price)*100)/100;
                  }*/

            if(product_price_discount > 0){
                full_new_price =Math.round((old_sum - product_price_discount)*100)/100;
            }
            /*
                  console.log('old_sum = ', old_sum);
                  console.log('full_new_price = ', full_new_price);*/

            day_nutrition.find('.day-protein').text(full_protein);
            day_nutrition.find('.day-fat').text(full_fat);
            day_nutrition.find('.day-carbs').text(full_carbs);
            day_nutrition.find('.day-cal').text(full_cal);

            $('.meal-pack-page .add-to-cart-plan .old-pack-sum').text(old_full_price);

            $('.meal-pack-page .add-to-cart-plan .new-pack-sum').text(full_new_price);

            product.find('.change-meal').addClass('hide');
            product.find('.delete-meal').addClass('hide');
            product.find('.meal-image').removeClass('full-product');
            product.addClass('empty-meal');
            product.find('.meal-nutrition').html(nutrition);

            product.find('.meal-title').text(variant_title);
            product.attr('data-variant', '');
            product.attr('data-variant-price', '0');
            product.attr('data-variant-price_discount', '0');
            product.find('.meal-image').empty();
        });

        function addProductsToEmpty(products){
            $('.meal-pack-page').on('click', '.empty-meal .meal-image', function () {
                $('.pop-up-change-meal').addClass('new-meal');
                $('.pop-up-change-meal h3').addClass('hide');
                $('.pop-up-change-meal-tabs span').removeClass('active');
                $('.pop-up-change-meal-tabs span:first-child').addClass('active');
                $('.collection-meals-block').empty();
                $('.meal').removeClass('product-to-change');
                $(this).parent().addClass('product-to-change');
                $('.pop-up-change-meal').removeClass('change-meal');
                $('body').addClass('active-pop-up');

                let meal_number = $(this).parent().find('.meal-number').text().replace('meal', ''),
                    special_meal = $(this).parent().data('special'),
                    first_price = 0;

                setProductsInPopUp(products, meal_number, special_meal, first_price);
            });
        }

        $('.pop-up-change-meal .close-pop-up-change-meal').click(function () {
            $('.pop-up-change-meal').addClass('hide').removeClass('change-meal new-meal special-meal').attr('data-change-price', '');
            $('body').removeClass('active-pop-up');
            $('.collection-meals-block').empty();
        });

    },

    addAllProducts: function(meal_packs_arr){
        $.ajax({
            method: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {items: meal_packs_arr },
            success: function (xhr) {
                ajaxCart.load();
                slate.cart.openDrawer();
                $('.meal-pack-page').find('.custom-spinner').addClass('hide');
            },
            error: function (xhr){
                console.log(xhr.responseText);
            }
        })
    },

    createMealItems: function(discount, arr_meals, mealPackId, old_sum){
        let set_discount = 0;
        let meal_packs_arr = [];

        for(let j = 0; arr_meals.length> j; j++){
            let productData = {},
                full_meal = arr_meals[j],
                $mealPackSection = $(full_meal).closest('.daily-meal-plan'),
                last_meal = arr_meals.length*1 - 1,
                meal_discount_full_price = $(full_meal).attr('data-variant-price')*100,
                meal_discount_part;

            productData.id = $(full_meal).data('variant')*1;
            productData.quantity = 1;

            if(discount > 0 ){
                if( j < last_meal ){
                    meal_discount_part = Math.round(meal_discount_full_price / old_sum * discount);
                    set_discount += meal_discount_part;
                } else if( j == last_meal ){
                    meal_discount_part = Math.round(discount - set_discount );
                }
            }

            productData.properties = {};
            productData.properties['_meal_pack_uniq_id'] = mealPackId;
            productData.properties['_meal_pack_prod_id'] = $mealPackSection.attr('data-id');
            productData.properties['Meal Pack'] = $mealPackSection.attr('data-title');
            productData.properties['Day'] = 'Day '+ $mealPackSection.attr('data-day');

            if (meal_discount_part > 0){
                productData.properties['_gwa_mp_discount_fixed'] = meal_discount_part;
            }

            meal_packs_arr.push(productData);
        }

        return meal_packs_arr
    },

    mealPackAddPlan: function (id_WM360){
        let _this = this;
        let mealPackId = +new Date();
        let add_pack_btn = $('[data-add-meal-pack-to-cart]');

        let old_sum = add_pack_btn.find('.old-pack-sum').text() * 100,
            new_sum = add_pack_btn.find('.new-pack-sum').text() * 100,
            discount;

        if (new_sum) {
            discount = Math.ceil(old_sum - new_sum);
        } else {
            discount = 0;
        }

        if((id_WM360 || id_WM360 == undefined ) && $('.days-meal-plan').data('mealpack-type') == "wm360"){
            id_WM360 = theme.productWM360Id * 1;
        }

        let arr_meals = $('.meal').filter(function( index, card ) {if(!$(card).hasClass('empty-meal')){ return card }});

        let meal_packs_arr = _this.createMealItems(discount, arr_meals, mealPackId, old_sum);

        if(id_WM360 && id_WM360 != undefined){
            let properties_block = $('.daily-meal-plan').first();
            let product_WM360 = {
                id : id_WM360,
                quantity: 1,
                properties : {
                    _meal_pack_uniq_id: mealPackId,
                    _meal_pack_prod_id: properties_block.attr('data-id'),
                    'Meal Pack': properties_block.attr('data-title'),
                    wm360: 'meal-pack'
                }
            };
            meal_packs_arr.push(product_WM360);
        }

        if (meal_packs_arr.length > 0) {
            _this.addAllProducts(meal_packs_arr);
        }
    },

    mealPackAddToCartProducts: function (){
        let _this = this;
        let id_WM360 = theme.productWM360Id * 1;

        $('.meal-pack-products').on('click', '[data-add-meal-pack-to-cart]', function (e) {
            e.preventDefault();
            if(id_WM360 > 0 && $('.mealPack-WM360__quiz').length > 0){
                $('.meal-pack-page').find('.custom-spinner').removeClass('hide');
                _this.mealPackAddPlan(id_WM360);
            }else if (!$('.days-meal-plan').hasClass('meal-pack-fixed') && $('.meal-pack-offer').length > 0 && $('.days-meal-plan').data('mealpack-type') != 'wm360'){
                $('body').find('.meal-pack-offer').removeClass('hide');
            }else{
                $('.meal-pack-page').find('.custom-spinner').removeClass('hide');
                _this.mealPackAddPlan();
            }
            $('body').addClass('active-pop-up');
        });

        $('.meal-pack-products').on('click', '[data-meal-pack-offer__agree]', function (){
            _this.mealPackAddPlan(id_WM360);
            if ($('.meal-pack-offer').length > 0) {
                $('body').find('.meal-pack-offer').addClass('hide');
            }
            $('.meal-pack-page').find('.custom-spinner').removeClass('hide');
        });

        $('.meal-pack-products').on('click', '[data-meal-pack-offer__disagree]', function (){
            _this.mealPackAddPlan();
            if ($('.meal-pack-offer').length > 0) {
                $('body').find('.meal-pack-offer').addClass('hide');
            }
            $('.meal-pack-page').find('.custom-spinner').removeClass('hide');
        });
    }
};

theme.MealPackAjaxSection = (function() {
    function MealPackAjaxSection(container) {
        var el_container = (this.el_container = $(container));

        this.selectors = {
            mealPackMainSelector: '.meal-pack-page',
            mealPackPageSelector: '.days-meal-plan',
        };

        this.settings = {
            ajaxTemplateUrlParam: 'view=' + el_container.attr('data-ajax-template'),
            namespace: '.mealPackAjaxSection'
        };

        var el_initialPage = $(this.selectors.mealPackPageSelector);
        this.startChangeMealPackListener(el_initialPage);
    }

    MealPackAjaxSection.prototype = Object.assign({}, MealPackAjaxSection.prototype, {
        startChangeMealPackListener: function(el_page) {
            var _this = this;

            $('.test-meal-pack .btn-days').click(function () {
                var gender = $('.question-content').data('gender'),
                    activity = $('.question-content').data('activity'),
                    content = $(this).data('days'),
                    days = content*1 - 5,
                    meal_pack_obj = meal_packs_test_answers[gender][activity][days],
                    meal_pack_key = Object.keys(meal_pack_obj)[0],
                    meal_pack_price = meal_pack_obj[meal_pack_key],
                    meal_pack_discount = meal_pack_price / 10,
                    meal_pack_new_price = meal_pack_price - meal_pack_discount,
                    mealPackUrl = '/products/' + meal_pack_key;

                $('#shopify-section-you-may-also-like').addClass('slow');
                $('#shopify-section-rich-text-with-image-copy').fadeOut('slow');

                window.history.pushState("/collections/", "Full Meals Pack", mealPackUrl);

                $.ajax({
                    type: 'GET',
                    url: mealPackUrl + '?' + _this.settings.ajaxTemplateUrlParam,
                    cache: false,
                    dataType: 'html',
                    success: function (data) {
                        $('.meal-pack-page').empty().append(data);
                        $('.meal-pack-products').fadeIn("slow");

                        if($('body').data('customer') != ""){
                            var userGA_obj = meal_pack_key+', Logged In, '+$('body').data('customer');
                        }else{
                            var userGA_obj = meal_pack_key;
                        }

                        if(window.ga){
                            ga('create', 'UA-34707600-1', 'auto');
                            ga('set', 'dimension1', userGA_obj );
// Send the custom dimension value with a pageview hit.
                            ga('send', 'pageview', userGA_obj);
                        }
                    }
                })
            });

            $('.question-meal-pack .btn-days').click(function () {
                var content = $(this).data('days'),
                    days = content*1 - 5,
                    meal_pack = meal_packs_days_answer[days],
                    mealPackUrl = '/products/' + meal_pack;

                $('#shopify-section-you-may-also-like').addClass('slow');
                $('#shopify-section-rich-text-with-image-copy').fadeOut('slow');

                window.history.pushState("/collections/", "Full Meals Pack", mealPackUrl);

                $.ajax({
                    type: 'GET',
                    url: mealPackUrl + '?' + _this.settings.ajaxTemplateUrlParam,
                    cache: false,
                    dataType: 'html',
                    success: function (data) {
                        $('.meal-pack-page').empty().append(data);
                        $('.meal-pack-products').fadeIn("slow");
                    }
                })
            });
        }
    });
    return MealPackAjaxSection;
})();

theme.MealPackWM360 = {
    meal_packs_arr: theme.meal_packs_WM360,
    meal_packs_template: [],
    meal_packs_days_count: [],
    meal_packs_meals_count: [],
    container_info: $('[data-section-mealPack-WM360]'),
    container: $('[data-section-mealPack-WM360-products]'),
    meal_pack_days: 0,
    meal_pack_collection_url: '',

    initQuiz: function (){
        let _this = this;
        let pack_goal = $(_this.container_info).data("pack-goal");
        let pack_gender = $(_this.container_info).data("pack-gender");

        _this.meal_pack_collection_url = window.location.href;
        _this.meal_packs_template = _this.meal_packs_arr.filter(function(meal_pack){
            return meal_pack.gender === pack_gender && meal_pack.goal === pack_goal;
        });

        _this.quizActions();
    },

    quizActions: function (){
        let _this = this;
        $('.btn-answer-wm360 [name="wm360-days"]').on('change click',function(){
            let btn = $(this);
            _this.meal_pack_days = btn.val();
            _this.filteringMealPacks('days', btn.val());
            _this.quizChangeBlocks('WM360-quiz__block-days', 'WM360-quiz__block-meals');
        });

        $('.btn-answer-wm360 [name="wm360-meals"]').on('change click',function(){
            let btn = $(this);
            let meals_quantity = _this.meal_pack_days * btn.val();
            _this.filteringMealPacks('quantity', meals_quantity);
            _this.quizChangeBlocks('WM360-quiz__block-meals', 'WM360-quiz__block-allergens');
        });

        $('[data-WM360-quiz-back]').click(function () {
            let block_close = $(this).data('close');
            let block_open = $(this).data('prev');
            _this.quizChangeBlocks(block_close, block_open);
            if (block_close == 'WM360-quiz__block-success'){
                window.history.pushState("/products/", "Collection Meals Pack WM360", _this.meal_pack_collection_url);
                $('.meal-pack-products').fadeOut("slow", function() {
                    $(_this.container).find('.meal-pack-page').empty();
                });
            }
        });

        $('[data-WM360-quiz-confirm]').click(function () {
            let allergens_arr = [];
            $('input[name="wm360-allergen"]:checked').each(function(){
                allergens_arr.push($(this).val());
            });
            if(allergens_arr.length > 0){
                _this.filteringAllergensMealPacks(allergens_arr);
            }else{
                if(_this.meal_packs_meals_count.length > 0){
                    _this.showMealPack(_this.meal_packs_meals_count[0].product_handle);
                    _this.quizChangeBlocks('WM360-quiz__block-allergens', 'WM360-quiz__block-success');
                }else{
                    _this.quizChangeBlocks('WM360-quiz__block-allergens', 'WM360-quiz__block-error');
                }
            }
        });
    },

    quizChangeBlocks: function (close_block, open_block){
        let _this = this;
        let index;

        $('.WM360-quiz__navigation span').removeClass('WM360-quiz__navigation-active');
        $('.'+close_block).fadeOut("slow", function() {
            $('.'+open_block).fadeIn("slow");
        });

        if(open_block == "WM360-quiz__block-days"){
            index = 1
        }else  if(open_block == "WM360-quiz__block-meals"){
            index = 2
            _this.setMealsQTY();
        }else  if(open_block == "WM360-quiz__block-allergens"){
            index = 3
        }else{
            index = 4
        }
        $('.WM360-quiz__navigation span:nth-child('+index+')').addClass('WM360-quiz__navigation-active');
    },

    setMealsQTY: function (){
        let _this = this;
        $('.WM360-quiz__block-meals .btn-answer-wm360').each(function (i, answer_block) {
            $(answer_block).find('.WM360-quiz__block-meals-days').text(_this.meal_pack_days);
            let meals_per_day = $(answer_block).find('input[name="wm360-meals"]').val();
            $(answer_block).find('.WM360-quiz__block-meals-days').text(_this.meal_pack_days);
            $(answer_block).find('.WM360-quiz__block-meals-qty').text(_this.meal_pack_days * meals_per_day);
        });
    },

    filteringMealPacks: function(question, answer){
        let _this = this;
        if(question == 'days'){
            _this.meal_packs_days_count = _this.meal_packs_template.filter(function(meal_pack){
                if(meal_pack[question] == answer){
                    return meal_pack
                }
            });
        }else{
            _this.meal_packs_meals_count = _this.meal_packs_days_count.filter(function(meal_pack){
                return meal_pack[question] == answer;
            });
        }
    },

    filteringAllergensMealPacks: function(allergens_arr){
        let _this = this;
        let answer_packs = _this.meal_packs_meals_count.filter(function(meal_pack) {
            let count_a = 0;
            $.each(meal_pack.allergens, function (key, value) {
                let index = $.inArray(value, allergens_arr);
                if (index > -1) {
                    count_a += 1;
                }

            });
            if (count_a < 1) {
                return meal_pack
            }
        });
        if(answer_packs.length>0){
            _this.showMealPack(answer_packs[0].product_handle);
            _this.quizChangeBlocks('WM360-quiz__block-allergens', 'WM360-quiz__block-success');
        }else{
            _this.quizChangeBlocks('WM360-quiz__block-allergens', 'WM360-quiz__block-error');
        }
    },

    showMealPack: function(meal_pack_key){
        let _this = this;
        let mealPackUrl = '/products/' + meal_pack_key;
        let ajaxTemplateUrlParam = 'view=' + $(_this.container).data('ajax-template');

        window.history.pushState("/collections/", "Full Meals Pack", mealPackUrl);

        $.ajax({
            type: 'GET',
            url: mealPackUrl + '?' + ajaxTemplateUrlParam,
            cache: false,
            dataType: 'html',
            success: function (data) {
                $(_this.container).find('.meal-pack-page').empty().append(data);
                $('.meal-pack-products').fadeIn("slow");
            },
            error: function (ex) {
                console.log(ex.responseText);
            }
        })
    }
};

/*===============================================
* delivery-map.js
* ================================================*/
/* DELIVERY FAQS */
$('.delivery-faqs-block button, .delivery-faqs-block__question').click(function () {
    let faq_block = $(this).parent();
    if(faq_block.hasClass('active')){
        faq_block.find('.delivery-faqs-block__answer').hide();
        faq_block.removeClass('active');
    }else{
        faq_block.find('.delivery-faqs-block__answer').fadeIn(200);
        faq_block.addClass('active');
    }
});

/*===============================================
* contact-faq.js
* ================================================*/
/* Contact FAQS */
$('.faq-question').click(function () {
    $(this).parent().siblings().find('.faq-answer').fadeOut(0);

    $(this).next('.faq-answer').fadeIn(400);
});

$('.faq-answer p:first-child').click(function () {
    $(this).parent('div').fadeOut(200);
});

/*===============================================
* customer.js
* ================================================*/
//Display customer's password
$('.showpass').on("click", function(){
    let type = $('.inputPassword').attr('type') == "text" ? "password" : 'text';
    $('.inputPassword').prop('type', type);

    if($('.inputPassword').attr('type') == "text"){
        $(".showpass").addClass("showpass-active");
    } else{
        $(".showpass").removeClass("showpass-active");
    }
});
/*===============================================
* single-product.js
* ================================================*/
if( $('body').hasClass('single-product')){
    loadProduct();
    checkProductVariantsInCart();
}

function loadProduct(){
    let nutritions_obj_product = {
        "protein": 0,
        "white_first": 0.2,
        "carbs": 0,
        "white_second": 0.2,
        "fat": 0,
        "white_third": 0.2,
    };

    nutritions_obj_product['protein'] = $('.product-section .block-full-protein td:nth-child(2) span').text()*1;
    nutritions_obj_product['carbs'] = $('.product-section .block-full-carbohydrate td:nth-child(2) span').text()*1;
    nutritions_obj_product['fat'] = $('.product-section .block-full-fat-total td:nth-child(2) span').text()*1;

    circleGraph(nutritions_obj_product, "nutritionCanvasProduct");
    lineGraph(nutritions_obj_product);
}

function checkProductVariantsInCart(){
    theme.Product.custom.checkProductVariantsInCart();
}

function changeVariantSingleProduct(variant){
    let nutritions_obj_product = {
        "protein": 0,
        "white_first": 0.2,
        "carbs": 0,
        "white_second": 0.2,
        "fat": 0,
        "white_third": 0.2,
    };
    nutritions_obj_product['protein'] = $(variant).data('protein')*1;
    nutritions_obj_product['carbs'] = $(variant).data('carbohydrate')*1;
    nutritions_obj_product['fat'] = $(variant).data('fat_total')*1;

    circleGraph(nutritions_obj_product, "nutritionCanvasProduct");
    lineGraph(nutritions_obj_product);
}

function getFullNutritionProduct(variant){
    let product_nutrition = {
            'block-full-calories' : $(variant).data('calories'),
            'block-full-energy' : $(variant).data('energy'),
            'block-full-protein' : $(variant).data('protein'),
            'block-full-fat-total' : $(variant).data('fat_total'),
            'block-full-saturated-fat' : $(variant).data('saturated_fat'),
            'block-full-carbohydrate' : $(variant).data('carbohydrate'),
            'block-full-sugar' : $(variant).data('sugar'),
            'block-full-sodium' : $(variant).data('sodium')
        },
        product_part_nutrition = {
            'block-full-calories' : $(variant).data('part-calories'),
            'block-full-energy' : $(variant).data('part-energy'),
            'block-full-protein' : $(variant).data('part-protein'),
            'block-full-fat-total' : $(variant).data('part-fat_total'),
            'block-full-saturated-fat' : $(variant).data('part-saturated_fat'),
            'block-full-carbohydrate' : $(variant).data('part-carbohydrate'),
            'block-full-sugar' : $(variant).data('part-sugar'),
            'block-full-sodium' : $(variant).data('part-sodium')
        };

    changeVariantSingleProductNutrition(product_nutrition, 2);
    changeVariantSingleProductNutrition(product_part_nutrition, 3);
}

function changeVariantSingleProductNutrition(nutrition_obj, position){
    let arr_keys = Object.keys(nutrition_obj);

    for(let i=0; arr_keys.length>i; i++){
        let element = arr_keys[i],
            row = $('table.all-nutrition-block').find('.'+element);
        row.find('td:nth-child('+ position +') span').text(nutrition_obj[element]);
    }
}

$('.product-section').on('click', '.product-variants button', function(){
    $('.product-variants button').each(function () {
        $(this).removeClass('active');
    });

    let variant = $(this),
        new_count = variant.data('qty');
    variant.addClass('active');

    $('.product-info__price').text(variant.data('price'));
    $('.calories-count span').text(variant.data('calories'));
    if(new_count>0){
        $('.product-content-count').removeClass('hide').find('.product-count').text(new_count);
        $('.product-content-add').addClass('hide');
    }else{
        $('.product-content-count').addClass('hide').find('.product-count').text(0);
        $('.product-content-add').removeClass('hide');
    }

    changeVariantSingleProduct(variant);
    getFullNutritionProduct(variant);
//}).on('click', '.product-form__submit', function(){
    // let element = $(this),
    // id = element.parent().parent().find('.product-variant-id').val(),
    // count = $('.product__buy-button-container .quantity__input').val();
    // addProduct(id);
}).on('click', '.product-add', function () {
    // let element = $(this),
    //     id = $('.product-variant.active').data('variant-id'),
    //     count = element.prev('span').text()*1 + 1;
    // element.prev('span').text(count);
    // $('.variant-'+id).data('qty', count);
    // addProduct(id);
}).on('click', '.product-remove', function () {
    // let element = $(this),
    //     id = $('.product-variant.active').data('variant-id'),
    //     qty = element.next('span').text()*1;

    // if(qty > 1){
    //     qty -= 1;
    // }else{
    //     qty = 0;
    // }

    // let params = {
    //     quantity: qty,
    //     id: id
    // };

    // removeProductCart(params);

    // $('.variant-'+id).data('qty', qty);
    // element.next('span').text(qty);
});

/* General Events On Collection page  */
checkProductsInCart();

// Actions on product-cart block

// .pp-carousel (carousel PDT cards)
// .pdt-pack__details (Single PDT pack section add to cart)
// .product__info-container (Single PDT add to cart)


$('.collections-wrapper, .collection-products-section, .product-recommendations-wrapper, .related-products, .recently-viewed, .product-list, .pp-carousel, .pdt-pack__details').on('click', '.product-variants span', function(){
    let variant = $(this);
    variant.parent().find('span').removeClass('active');
    setTimeout(changeVariant, 50, variant);
    variant.addClass('active');
}).on('click', '.product-content-add', function(){
    let element = $(this),
    id = element.parent().find('#variant').val(),
    count = element.parent().find('#quantity').val()*1 + 1;
    element.parent().parent().find('.variant-'+id+' .variant-count').html('<span>'+count+'</span>');
    element.addClass('hide');
    element.next('.product-content-count').removeClass('hide').find('.product-count').text(count);

    let span =  element.parent().parent().prev('.product-variants').find('.variant-'+id);
    span.data('qty', count);
    var data_region = element.attr('data-region');
    addProduct(id);
}).on('click', '.quick-add__submit', function(e){
    let element = $(this),
    id = element.parent().find('input[name="id"]').val(),
    count = element.parent().find('#quantity').val()*1 + 1,
    data_region = element.attr('data-region');

    element.find('.add-to-cart-message').addClass('button-inactive');

    element.parent().find('.product-content-count, .content-product-add').removeClass('hide');
    element.parent().find('.product-count').text(count);
    console.log("count: ", count);

    let span =  element.parent().prev('.product-variants').find('.variant-'+id);
    span.data('qty', count);

    addProduct(id);

}).on('click', '.product-add', function () {
    let element = $(this),
    data_region = element.attr('data-region'),
    id = element.parent().parent().find('#variant').val();

    addProduct(id);

    let count = element.prev('span ').text()*1 + 1;
    element.prev('span').text(count);

    let span =  element.parent().prev('.product-variants').find('.variant-'+id);
    span.data('qty', count);
    span.find('.variant-count').removeClass('hide').html('<span>'+count+'</span>');

}).on('click', '.product-remove', function () {
    let element = $(this),
    id = element.parent().parent().find('#variant').val(),
    qty = element.next('span').text()*1;

    if (qty>0) {
        if (qty === 1) {
            element.parent().parent().addClass('hide');
            element.closest('.product-form').find('.add-to-cart-message').removeClass('button-inactive');
        }
        qty -= 1;
    } else {
        qty = 0;
    }

    let params = {
        quantity: qty,
        id: id
    };

    removeProductCart(params);
    element.next('span').text(qty);
});

// const quickViewSubmitBtn = document.querySelectorAll(
//     'quick-add-modal.quick-add-modal .product__info-container .product-form__submit'
//   );
// quickViewSubmitBtn.addEventListener('click', (evt) => console.log(evt) );

// function quickViewSubmit(id) {
//     const target = document.querySelector('#QuickAdd-'+id+'.quick-add-modal .quick-add-modal__content-info');
//     const observer = new MutationObserver(callbackMutation);
//     observer.observe(target, { attributes: true });   
//     callbackMutation(mutations);l  
//     console.log('pack', target);
// }

// function callbackMutation(mutations) {
//     mutations.forEach((mutation) => {
//     console.log(
//         `Attribute ${mutation.attributeName} changed to ${mutation.target.getAttribute(mutation.attributeName)}`
//     );
//     });
// }

/*
    Individual Product function
*/
$('.product__info-container').on('click', '.product-form__submit', function(){
    let element = $(this),
    id = element.parent().find('input[name="single-pdt-id"]').val(),
    count = element.parent().find('#single-pdt-quantity').val()*1 + 1;
    element.find('.add-to-cart-message').addClass('button-inactive');
    element.parent().find('.product-content-count, .content-product-add').removeClass('hide');
    element.parent().find('.product-count').text(count);

    let span =  element.parent().prev('.product-variants').find('.variant-'+id);
    span.data('qty', count);
    addProduct(id);
}).on('click', '.product-add', function () {
    let element = $(this),
    id = element.parent().parent().find('#single-pdt-variant').val();
    addProduct(id);
    let count = element.prev('span').text()*1 + 1;
    element.prev('span').text(count);

    let span =  element.parent().prev('.product-variants').find('.variant-'+id);
    span.data('qty', count);
    span.find('.variant-count').removeClass('hide').html('<span>'+count+'</span>');

}).on('click', '.product-remove', function () {
    let element = $(this),
    id = element.parent().parent().find('#single-pdt-variant').val(),
    qty = element.next('span').text()*1;
    if(qty>0){
        qty -= 1;
    }else{
        qty = 0;
    }
    let params = {
        quantity: qty,
        id: id
    };
    removeProductCart(params);
    element.next('span').text(qty);
});



$('.collection-product-pop-up .product-variants').on('click', 'button', function () {
    $('.collection-product-pop-up .product-variants button').removeClass('active');
    $('.product-pop-up-add .product-content-count').addClass('hide');
    $('.product-pop-up-add .product-content-count .product-count').text('0');
    $('.collection-product-pop-up .product-pop-up-add .add-button').removeClass('hide');
    let full_data = $(this),
        main_block = $('.main-product-content'),
        nutritions_obj = {
            "protein": 0,
            "white_first": 0.2,
            "carbs": 0,
            "white_second": 0.2,
            "fat": 0,
            "white_third": 0.2,
        },
        full_nutritions = {},
        variant_qty = full_data.data('variant-qty');
    full_data.addClass('active');
    main_block.find('.ingredients-content').text(full_data.data('variant-ingredients'));
    main_block.find('.calories-count span').text(full_data.data('variant-calories'));
    $('.product-pop-up-add .price').text('$'+full_data.data('variant-price'));

    if(variant_qty*1 > 0){
        $('.product-pop-up-add .product-content-count').removeClass('hide');
        $('.product-pop-up-add .product-content-count .product-count').text(variant_qty);
        $('.collection-product-pop-up .product-pop-up-add .add-button').addClass('hide');
    }else{
        $('.product-pop-up-add .product-content-count .product-count').text('0');
    }

    nutritions_obj['protein'] = full_data.data('variant-protein');
    nutritions_obj['carbs'] = full_data.data('variant-carbohydrate');
    nutritions_obj['fat'] = full_data.data('variant-fat-total');

    full_nutritions['Protein'] = full_data.data('variant-protein');
    full_nutritions['Carbohydrate'] = full_data.data('variant-carbohydrate');
    full_nutritions['Fat_Total'] = full_data.data('variant-fat-total');

    full_nutritions['Energy_KJ'] = full_data.data('variant-energy');
    full_nutritions['Calories'] = full_data.data('variant-calories');
    full_nutritions['Saturated_Fat'] = full_data.data('variant-saturated-fat');
    full_nutritions['Sugar'] = full_data.data('variant-sugar');
    full_nutritions['Sodium'] = full_data.data('variant-sodium');
    full_nutritions['Fiber'] = full_data.data('variant-fiber');

    lineGraph(nutritions_obj);
    circleGraph(nutritions_obj, "nutritionCanvas");
    createFullNutritions(full_nutritions);

});

$('.close-collection-popUp').click(function(){
    $('.collection-product-pop-up').addClass('hide');
    $('body').removeClass('active-pop-up');
    $('.all-nutrition-block').fadeOut();
    $('.nutrition-lines button').removeClass('in-block');
    checkProductsInCart();
});

$('.nutrition-lines button').click(function () {
    let element = $(this);
    if( element.hasClass('in-block')){
        $('.all-nutrition-block').fadeOut();
        element.removeClass('in-block');
        element.html("all nutrition facts");
    }else{
        $('.all-nutrition-block').fadeIn();
        element.addClass('in-block');
        element.html("close All Nutrition Facts");
    }
});

/* collection Product block -> Pop Up add to cart */

$('.collection-product-pop-up').on('click', '.product-pop-up-add .add-button', function (){
    $(this).addClass('hide');
    $('.product-pop-up-add .product-content-count').removeClass('hide');

    let variant_button = $('.collection-product-pop-up .product-variant.active'),
        id = variant_button.data('variant-id'),
        qty = $('.product-pop-up-add .product-count').text()*1 + 1;

    addProduct(id);
    $('.product-pop-up-add .product-count').text(qty);
    variant_button.data('variant-qty', qty);
}).on('click', '.product-pop-up-add .product-content-count .product-add', function (){
    let variant_button = $('.collection-product-pop-up .product-variant.active'),
        id = variant_button.data('variant-id'),
        qty = $('.product-pop-up-add .product-count').text()*1 + 1;

    addProduct(id);
    $('.product-pop-up-add .product-count').text(qty);
    variant_button.data('variant-qty', qty);
}).on('click', '.product-pop-up-add .product-content-count .product-remove', function (){
    let variant_button = $('.collection-product-pop-up .product-variant.active'),
        id = variant_button.data('variant-id'),
        qty = $('.product-pop-up-add .product-count').text()*1;

    if(qty > 1){
        qty -= 1;
    }else{
        qty = 0;
    }

    $('.product-pop-up-add .product-count').text(qty);
    if(qty == 0){
        $('.product-pop-up-add .product-content-count').addClass('hide');
        $('.collection-product-pop-up .product-pop-up-add .add-button').removeClass('hide');
    }
    variant_button.data('variant-qty', qty);

    let params = {
        quantity: qty,
        id: id
    };

    removeProductCart(params);
});

/* Collection filters - update */
theme.CollectionFilters = (function(){
    function CollectionFilters(container) {
        var $container = (this.$container = $(container));
        this.initFilters();
    }
    CollectionFilters.prototype = $.extend({}, CollectionFilters.prototype, {
        initFilters: function(){
            var _this = this;
            this.$productGridItems = $('.product-grid-item');
            this.$clearAllFilters = $('.clear-all-filters');
            this.$noFilterResults = $('.no-filter-results');
            this.$filterItems = $('.collection-filter-item');
            this.$adBlocks = $('.ad-grid-item');
            this.$clonedAds = this.$adBlocks.clone().addClass('ad-grid-item-cloned')
            this.$collectionSections = $('.collection-section');

            this.$filterItems.on('click', function(){
                $(this).toggleClass('active-filter');
                _this.filterProducts();
            });

            this.$clearAllFilters.on('click', function(){
                _this.$filterItems.removeClass('active-filter');
                _this.filterProducts();
            });

            $('.collection-filter-btn').on('click', function(){
                var $filter = $(this).closest('.collection-filter');
                $('.collection-filter-open').not($filter).find('.collection-filter-dropdown').slideUp(200);
                $('.collection-filter-open').not($filter).removeClass('collection-filter-open');
                if ($filter.hasClass('collection-filter-has-dropdown')) {
                    $filter.toggleClass('collection-filter-open');
                    $('.collection-filter-dropdown', $filter).slideToggle(200);
                }
            });

            $('.show-filters').click(function () {
                $('.collection-filters-wrapper').slideToggle(200);
                $('.close-filters').toggle();
            });

            $('.close-filters').click(function () {
                $('.collection-filters-wrapper').slideUp(200);
                $(this).hide();
            });

        },
        filterProducts: function(){
            var _this = this;
            var $activeFilters = $('.active-filter');
            this.$clearAllFilters.hide();
            this.$noFilterResults.hide();
            $('.has-active-filter').removeClass('has-active-filter');
            this.$productGridItems.removeClass('product-filtered');
            $('.ad-grid-item-cloned').remove();
            this.$collectionSections.show();
            if ($activeFilters.length) {
                $activeFilters.closest('.collection-filter').addClass('has-active-filter');
                _this.$clearAllFilters.show();
            }
            else {
                _this.$clearAllFilters.hide();
                this.$productGridItems.fadeIn(300);
                this.$adBlocks.fadeIn(300);
                return;
            }

            this.$productGridItems.hide();
            this.$adBlocks.hide();

            var $activeFiltersGroups = $activeFilters.closest('.collection-filter');
            this.$productGridItems.each(function(){
                var matchFilters = [];
                var $productGridItem = $(this);
                $activeFiltersGroups.each(function(){
                    var shouldBeExcepted = $(this).attr('data-exception-rule') === 'true';
                    var matchFilter = shouldBeExcepted ? 1 : 0;
                    $('.active-filter', $(this)).each(function(){
                        var filterValue = $(this).attr('data-filter-value');
                        if ($productGridItem.attr('data-tags') != undefined) {
                            var productTags = $productGridItem.attr('data-tags').split(',');
                            if (productTags.indexOf(filterValue) >= 0) {
                                matchFilter = shouldBeExcepted ? 0 : 1;
                                return false;
                            }
                        }
                    });
                    matchFilters.push(matchFilter);
                });

                if (matchFilters.indexOf(0) < 0) {
                    $productGridItem.addClass('product-filtered');
                    $productGridItem.fadeIn(300);
                }
            });
            this.$collectionSections.each(function(){
                var $collectionSection = $(this);
                if (!$('.product-filtered', $collectionSection).length) {
                    $(this).hide();
                }
            });

            if (!$('.product-filtered').length) {
                this.$clearAllFilters.filter('.clear-all-filters-desktop').hide();
                this.$noFilterResults.show();
            }
            else if ($('.product-filtered').length != this.$productGridItems.length) {
                var adPositionAfterEach = Math.floor($('.product-filtered').length / this.$clonedAds.length);
                if (adPositionAfterEach < 3) {
                    adPositionAfterEach = 3;
                }
                this.$clonedAds.each(function(ind){
                    $(this).insertAfter($('.product-filtered').eq((ind+1)*adPositionAfterEach - 1)).fadeIn(300);
                });
            }
        }
    });
    return CollectionFilters;
})();
//Script for page search results

function openSearchResults(evt, desc) {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent__search");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].className = tabcontent[i].className.replace("show", "");
    }
    tablinks = document.getElementsByClassName("tablinks__search");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(desc).style.display = "block";
    document.getElementById(desc).className += " show";
    evt.currentTarget.className += " active";
}

$('.tablinks__search').on('click', function(){
    let tab = "tabcontent-"+ $(this).attr("data-handle");
    openSearchResults(event, tab);
});


$(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('collection-filters', theme.CollectionFilters);
    theme.mealPackProducts.mealPackTest();
    theme.mealPackProducts.mealPackTestResult();
    //theme.mealPackProducts.mealPackAddToCartProducts();
    //theme.mealPackProducts.mealPackChangeProduct();

    sections.register('mealPack', theme.MealPackAjaxSection);

    if (window.theme.cartType === "page") {
        slate.cart.cartChangeQTY();
        slate.cart.cartClear();
        slate.cart.cartCheckTotal();
    }

    // slate.subscriptions.canceledSubscription();

    sections.register('deliveryMap', theme.DeliveryMapSection);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    Slideshow();
    SimpleSlider();
    SlideshowMealpacks();
    SlideArticles();
    SliderRelatedProducts();
    SlideshowChannels();

    AboutUsSlider();
    ReviewsSlider();
    BlogSlider();

    //Title fade in and change color
    let duration = 500;
    $(".title-fade-in").each(function(index) {
        //$(this).delay(duration*index).fadeIn(duration);
        $(this).delay(duration * index).animate({
            opacity: 1
        }, duration, function() {
            $(this).delay(duration).css("color", "var(--color-primary)");
        });
    });

    //Fade in photo description on header slider
    function fadeInDescription() {
        let duration = 700;
        $(".stripe").each(function (index) {
            $(this).delay(duration * index).animate({
                opacity: 1
            }, duration, function () {
                $(this).delay(duration).addClass("stripe-active").css("color", "#010101");
            });
        });
    }

    let delayAnimation = 0.3;
    setTimeout(fadeInDescription, delayAnimation * duration);

    //Tab with collection
    $(".tablinks-collection:eq(0)").addClass("active");
    $(".tabcontent-collection:eq(0)").css("display","block");
    $(".tabcontent-collection:eq(0)").css("opacity","1");

    equalHeight($(".step-title-wrappper"));
    getMarginForSlide($(".meal-packs-section"));

    if ($('.homepage-video-with-mobile').length > 0 && ($('.homepage-video-with-mobile').attr('src-webm-mob') != ''
        || $('.homepage-video-with-mobile').attr('src-mp4-mob') != ''
        || $('.homepage-video-with-mobile').attr('src-ogg-mob') != '')){
        videoConteinerSource($(window).width());
    }

});

$('.co-worker_all').on('click', function (e) {
    $(this).fadeOut();
    setTimeout(function () {
        $('.hidden--co-worker').slideDown(500);
    }, 450);
});

/*popUp buy more*/
$('.cart-drawer__buy-more').on('click', '.product-content-add', function (){
    let add_button = $(this),
        add_block = add_button.parent(),
        id = add_button.parent().data('product-id'),
        qty = add_button.parent().find('.product-count').text()*1 + 1;

    add_button.addClass('hide');
    add_block.find('.product-content-count').removeClass('hide');

    addMoreProduct(id);

    add_block.find('.product-count').text(qty);

}).on('click', '.product-add', function (){
    let add_button = $(this),
        add_block = add_button.parent().parent(),
        id = add_block.data('product-id'),
        qty = add_block.find('.product-count').text()*1 + 1;

    addMoreProduct(id);

    add_block.find('.product-count').text(qty);

}).on('click', '.product-remove', function (){
    let remove_button = $(this),
        remove_block = remove_button.parent().parent(),
        id = remove_block.data('product-id'),
        qty = remove_block.find('.product-count').text()*1;

    if(qty > 1){
        qty -= 1;
    }else{
        qty = 0;
    }

    remove_block.find('.product-count').text(qty);

    if(qty == 0){
        remove_block.find('.product-content-count').addClass('hide');
        remove_button.removeClass('hide');
        remove_block.children()[0].classList.remove("hide");
    }

    let params = {
        quantity: qty,
        id: id
    };

    removeProductCart(params);
});


function addMoreProduct(id){
    let data = {
        quantity: 1,
        selling_plan: sellingPlanIdShared, // Include updated selling plan
        id: id
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function() {
            setTimeout(cartIcon, 50);
            $('.cart-drawer__buy-more footer .buy-more__close').text('checkout');
        },
        error: function(XMLHttpRequest, textStatus) {
            console.log(textStatus);
            console.log(XMLHttpRequest);
        }
    });
}

$('.cart-drawer__buy-more').on('click', '.buy-more__close', function (){
    $('.cart-drawer__buy-more').removeClass('active');
    $('#CartDrawer').removeClass('hide-for-buy-more');

    if($('.gifts-block__gift').length > 0){
        checkProgressBarGifts();
    }else{
        showDrawerSpinner();
        setDrawerAttributes();
        $('.drawer__count').addClass('hide');
    }
});


/*================ Page WM-360 video ================*/
window.addEventListener('DOMContentLoaded', function() {
    if (document.querySelectorAll(".video-autoplay-block").length > 0) {
        document.querySelectorAll(".video-autoplay-block")[0].play();
    }
});

if(document.querySelectorAll('.wm-360-main__video .video-play, .wm-360-video .video-play').length > 0){
    document.querySelectorAll('.wm-360-main__video .video-play, .wm-360-video .video-play')[0].addEventListener('click', function(el) {
        let video = this.previousElementSibling;
        video.play();
        video.classList.add('video-play-active');
    });

    document.querySelectorAll('.wm-360-main__video video, .wm-360-video video')[0].addEventListener('click', function(el) {
        let video = this;
        if(this.classList.contains('video-play-active')){
            video.pause();
            video.classList.remove('video-play-active');
        }
    });

    document.querySelectorAll('.wm-360-main__video .video-sound-off, .wm-360-video .video-sound-off')[0].addEventListener('click', function(el) {
        let button = this;
        let button_on = this.previousElementSibling;
        button.classList.add('hide');
        button_on.classList.remove('hide');
        button.parentNode.querySelector('video').muted = true;
    });
    document.querySelectorAll('.wm-360-main__video .video-sound-on, .wm-360-video .video-sound-on')[0].addEventListener('click', function(el) {
        let button = this;
        let button_off = this.nextElementSibling;
        button.classList.add('hide');
        button_off.classList.remove('hide');
        button.parentNode.querySelector('video').muted = false;
    });
}
/*================ Page WM-360 form ================*/
$('.wm-360-buy-meals-pack button').click(function(){
    $('.wm-360-buy-meals-pack button').attr('disabled', true);
    let button = $(this);
    let variant_id = button.data('variant');
    let analytics_url = button.parent().parent().parent().parent().data('from');
    let data = {
        quantity: 1,
        id: variant_id,
        properties: {'wm360': 'meal-pack'}
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function() {
            if(window.ga){
                //   ga('create', 'UA-34707600-1', 'auto');
                ga('set', 'dimension2', analytics_url );
// Send the custom dimension value with a pageview hit.
                ga('send', 'event', 'Button', 'add_to_cart', analytics_url);
                //  ga('send', 'event', 'dimension2', 'set', analytics_url);
            }
            button.find('span').last().addClass('hide');
            button.find('span').first().removeClass('hide');
            $('.wm-360-buy-meals-pack button').attr('disabled', false);
            setTimeout(cartIcon, 50);
            $('.header-cart.js-drawer-open-button-right').trigger("click");
            setTimeout(function () {
                returnButtonTitle(button);
            }, 3000)
        },
        error: function(XMLHttpRequest, textStatus) {
            console.log(textStatus);
            console.log(XMLHttpRequest);
        }
    });
});


$('.template-page-workout-meals-360 a[href="#open_form"]').click(function(e){
    e.preventDefault();
    $('.pop-up-wm-360-form').removeClass('hide');
    $('body').addClass('active-pop-up');

    var calendar_id = $(".pop-up-wm-360-form").find("#general-question__datepicker");
    var time_id = $(".pop-up-wm-360-form").find("#general-question__timepicker");

    datePickerHome(calendar_id, time_id);
    timePickerHome(time_id);
});

$('.template-page-workout-meals-360 a[href="#wm-360-buy-pack"]').click(function(event){
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $(".wm-360-buy-meals-pack").offset().top - 100
    }, 700);
});

$('.pop-up-wm-360-form').on('click', 'header button, .btn-close-form', function(){
    $('.pop-up-wm-360-form').addClass('hide');
    $('body').removeClass('active-pop-up');
});

$('.pop-up-wm-360-form').on('click', '.btn-save-form', function(){
    let button = $(this);
    if($('.pop-up-wm-360-form').hasClass('static-form')){
        let pop_up = $('.pop-up-wm-360-form.static-form');
        checkFirstFormRequired(pop_up);
    }else{
        let pop_up = $(this).parent().parent().find('.first-section-questions');
        button.attr("disabled", true);
        if(!$('.pop-up-wm-360-form .first-section-questions').hasClass('hide')){
            checkFirstFormRequired(pop_up);
        }else{
            checkAllAnswersRequired(pop_up);
        }
    }
});

$('.pop-up-wm-360-form').on('change keyup input click', 'input[type="number"]', function(){
    let input_value = $(this).val();
    input_value = input_value.replace(/[^0-9]/g, '');
    if(input_value.length > 3){
        input_value = input_value.substr(0, 3);
    }
    $(this).val(input_value);
});

$('.pop-up-wm-360-form').on('change keyup input click', 'input', function(){
    $('.pop-up-wm-360-form').find('.btn-save-form').attr('disabled', false);
});

$('.pop-up-wm-360-form').on('change keyup input click', '.general-question__name input, .general-question__last-name input', function(){
    let input_value = $(this).val();
    input_value = input_value.replace(/[^A-z/-]/g, '');
    if(input_value.length > 20){
        input_value = input_value.substr(0, 20);
    }
    $(this).val(input_value);
});

$('.pop-up-wm-360-form').on('change keyup input click', '.general-question__phone input', function(){
    let input_value = $(this).val();
    input_value = input_value.replace(/[^0-9/+]/g, '');
    if(input_value.length > 20){
        input_value = input_value.substr(0, 20);
    }
    $(this).val(input_value);
});


if($('body').hasClass('template-page-workout-meals-360-form')){
    onBoardingForm();
}

/* Collection Goal Meal-pack Banner */
$('.banner-meal-pack--description-btn').click(function(){
    if($(this).hasClass('show-more')){
        $('.description-second').addClass('hide');
        $('.description-dots').removeClass('hide');
        $(this).removeClass('show-more');
    }else{
        $('.description-second').removeClass('hide');
        $('.description-dots').addClass('hide');
        $(this).addClass('show-more');
    }
})

/*Location tabs*/
$('.locations').on('click', 'a[role="tab"]', function () {
    $("a[role='tab']").attr("aria-selected","false");
    $(this).attr("aria-selected","true");

    openTabpanel($(this));
});

function openTabpanel(element) {
    let tabpanelid= element.attr("aria-controls"),
        tabpanel = $("#"+tabpanelid);

    $("div[role='tabpanel']").attr("aria-hidden","true").hide();
    tabpanel.attr("aria-hidden","false").show();
}

/*===============================================
* why-workout-meals.js
* ================================================*/
//Slider with points
// $(".points-slider").slick({
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     speed: 2000,
//     autoplaySpeed: 3000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: true,
//     cssEase: 'ease',
//     pauseOnHover: true,
//     customPaging: function(slider, i) {
//         let img = $(slider.$slides[i]).data("point");
//         return '<a>'+img+'</a>';
//     }
// });


/*===============================================
* the-goal.js
* ================================================*/
//Script for section the goal

function openTabcontent(evt, desc) {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent-goal");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].style.opacity = 0;
    }
    tablinks = document.getElementsByClassName("tablinks-gender");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(desc).style.display = "block";
    evt.currentTarget.className += " active";
}
$('.tablinks-gender').on('click', function(){
    $("#tabcontent-"+ $(this).attr("data-gender")).css("height", "max-content");
    openTabcontent(event, "tabcontent-"+ $(this).attr("data-gender"));
    $("#tabcontent-" + $(this).attr("data-gender")).animate({
        opacity: 1
    }, 900 );
});

// Tabs height alignment
function equalHeight(group) {
    let tallest = 0;
    group.each(function() {
        let thisHeight = $(this).height();
        if(thisHeight > tallest) {
            tallest = thisHeight;
        }
    });
    group.height(tallest);
}

// $(document).on('shopify:section:select', goalSlideMale);
// $(document).on('shopify:section:load', goalSlideMale);
// $(document).on('shopify:section:select', goalSlideFemale);
// $(document).on('shopify:section:load', goalSlideFemale);

// Slider for goal section
// function goalSlideMale() {
//     $('.goal-info-male').slick({
//         dots: true,
//         autoplay: false,
//         infinite: true,
//         speed: 800,
//         slidesToShow: 1,
//         arrows: false,
//         fade: true,
//         swipe: false,
//         cssEase: 'ease',
//         customPaging: function (slider, i) {
//             let thumb = $(slider.$slides[i]).data("title");
//             return '<a>'+thumb+'</a>';
//         }
//     });
// }

// function goalSlideFemale() {
//     $('.goal-info-female').slick({
//         dots: true,
//         autoplay: false,
//         infinite: true,
//         speed: 800,
//         slidesToShow: 1,
//         arrows: false,
//         fade: true,
//         swipe: false,
//         cssEase: 'ease',
//         customPaging: function (slider, i) {
//             let thumb = $(slider.$slides[i]).data("title");
//             return '<a>'+thumb+'</a>';
//         }
//     });
// }

/*===============================================
* meal-packs.js
* ================================================*/
$(document).on('shopify:section:select', SlideshowMealpacks);
// $(document).on('shopify:section:load', SlideshowMealpacks);
document.addEventListener("DOMContentLoaded", SlideshowMealpacks)
function SlideshowMealpacks() {
    // $('.meal-packs-section').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     /*centerMode: false,
    //      centerPadding: '0px',*/
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     customPaging : function(slider, i) {
    //         let thumb = $(slider.$slides[i]).data("title");
    //         let link = '#'+thumb.toLowerCase().trim().replace(/ /ig, '-');
    //         return '<a href="'+ link +'" title="link to '+thumb+'">'+thumb+'</a>';
    //     },
    //     responsive: [
    //         {
    //             breakpoint:950,
    //             settings: {
    //                 slidesToShow: 3
    //             }
    //         },
    //         {
    //             breakpoint: 750,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1
    //             }
    //         }
    //     ]
    // })
}

// =require sections/meal-packs-without-center.js

/*===============================================
* product-card-grid.js
* ================================================*/
//Product card grid
//Display variant product

function openProdDesc(evt, desc, dataProdId) {
    let i, tabcontent, tablinks;

    tablinks = document.getElementsByClassName("tablinks-" + dataProdId);
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    tabcontent = document.getElementsByClassName("tabcontent-" + dataProdId);
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    document.getElementById(desc).style.display = "block";
    evt.currentTarget.className += " active";
}

$('.tablinks').on('mouseover', function(){
    let dataProdId = $(this).attr("data-product-id");

    if( dataProdId == $(this).parent().attr("data-product-id") ){
        let tab = "tabcontent-"+ $(this).attr("data-variant")+"-"+$(this).html();
        openProdDesc(event, tab, dataProdId);
    }
});

$('.tablinks').on('click', function(e){
    e.preventDefault();
});
/*===============================================
* collections.js
* ================================================*/
//Section collections tab

function openCollectionProduct(evt, desc) {
    let i, tabcontent, tablinks;
    //tabcontent = document.getElementsByClassName("tabcontent-collection");
    tabcontent = evt.currentTarget.parentElement.parentElement.getElementsByClassName("tabcontent-collection");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].className = tabcontent[i].className.replace("show", "");
    }
    //tablinks = document.getElementsByClassName("tablinks-collection");
    tablinks = evt.currentTarget.parentElement.parentElement.getElementsByClassName("tablinks-collection");

    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(desc).style.display = "block";
    document.getElementById(desc).className += " show";
    evt.currentTarget.className += " active";
}

$('.tablinks-collection').on('mouseover', function(){
    let tab = "tabcontent-"+ $(this).attr("data-collection-handle");
    openCollectionProduct(event, tab);
});

$(".tabcontent-collection").css("display","none");

//Tab with collection
$(".popular-menu .tablinks-collection:eq(0)").addClass("active");
$(".popular-menu .tabcontent-collection:eq(0)").css("display","block");

//Tab with collection
$(".main-information .tablinks-collection:eq(0)").addClass("active");
$(".main-information .tabcontent-collection:eq(0)").css("display","block");


/*===============================================
* slider.js
* ================================================*/
// Slideshow section
$(document).on('shopify:section:select', Slideshow);
$(document).on('shopify:section:load', Slideshow);

$(document).on('shopify:section:select', SlideshowChannels);
$(document).on('shopify:section:load', SlideshowChannels);

$(document).on('shopify:section:select', SimpleSlider);
$(document).on('shopify:section:load', SimpleSlider);

$(document).on('shopify:section:select', BlogSlider);
$(document).on('shopify:section:load', BlogSlider);

$(document).on('shopify:section:select', AboutUsSlider);
$(document).on('shopify:section:load', AboutUsSlider);

$(document).on('shopify:section:select', ReviewsSlider);
$(document).on('shopify:section:load', ReviewsSlider);

function Slideshow() {
    let time = $('.template-index .slideshow-section').attr("data-slide-speed") * 1000;

    // $('.template-index .slideshow-section').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     autoplay: true,
    //     autoplaySpeed: time,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     pauseOnFocus: true,
    //     pauseOnHover: true
    // });

}

function SlideshowChannels() {
    let slide_time = $('.section-channels section').attr("data-slide-speed") * 1000;

    // $('.channels-slider').slick({
    //     autoplay: true,
    //     autoplaySpeed: slide_time,
    //     dots: false,
    //     infinite: true,
    //     speed: 1000,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     responsive: [
    //         {
    //             breakpoint: 800,
    //             settings: {
    //                 slidesToShow: 3
    //             }
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         },
    //         {
    //             breakpoint: 450,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         }
    //     ]
    // });
}

function SimpleSlider() {
    let time = $('.simple-slider-section').attr("data-slide-speed") * 1000;

    // $('.simple-slider-section').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     autoplay: true,
    //     autoplaySpeed: time,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false
    // });
}

function BlogSlider() {
    let time = $('.blog-banner-slider .simple-slider-section').attr("data-slide-speed") * 1000;

    // $('.blog-banner-slider .simple-slider-section').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     autoplay: true,
    //     autoplaySpeed: time,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false
    // });
}

function AboutUsSlider() {
    let time = $('.about-us-slider .slider-after-video').attr("data-slide-speed") * 1000;

    // $('.about-us-slider .slider-after-video').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     autoplay: true,
    //     autoplaySpeed: time,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     pauseOnFocus: true,
    //     pauseOnHover: true
    // });

}

function ReviewsSlider() {
    let time = $('.about-us-featured-reviews').attr("data-slide-speed") * 1000;

    // $('.featured-reviews-content').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     autoplay: true,
    //     autoplaySpeed: time,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     fade: true,
    //     cssEase: 'linear',
    //     centerMode: true,
    //     centerPadding: '0px',
    //     customPaging: function(slider, i) {
    //         let thumb = $(slider.$slides[i]).data('thumb');
    //         return '<img src="'+thumb+'">';
    //     }
    // });

}

//Slide video for mobile
$(window).on('resize', function () {
    if ($('.homepage-video-with-mobile').length > 0 && ($('.homepage-video-with-mobile').attr('src-webm-mob') != ''
        || $('.homepage-video-with-mobile').attr('src-mp4-mob') != ''
        || $('.homepage-video-with-mobile').attr('src-ogg-mob') != '')){
        videoConteinerSource($(window).width());
    }
});

function videoConteinerSource (windowWidth) {
    let videoConteiner = $('.homepage-video-with-mobile');

    videoConteiner.each(function(){
        let videoTag = $(this),
            videoWidth = '',
            videoW = videoTag.attr("src-webm"),
            videoM = videoTag.attr("src-mp4"),
            videoO = videoTag.attr("src-ogg");

        if(windowWidth < 768) {
            videoWidth = windowWidth - 24;
            videoW = videoTag.attr("src-webm-mob");
            videoM = videoTag.attr("src-mp4-mob");
            videoO = videoTag.attr("src-ogg-mob");
        }

        if (videoTag.attr("width") != videoWidth) {
            videoTag.empty();
            videoTag.attr("width", videoWidth).append('<source src="' + videoW + '" type="video/webm"><source src="' + videoM + '" type="video/mp4"><source src="' + videoO + '" type="video/ogg">Your browser does not support the video tag.');
            videoTag[0].load();
        }
    });
}
// =require sections/steps-with-image.js

/*===============================================
* blog-and-articles.js
* ================================================*/
//Slider for related articles

$(document).on('shopify:section:select', SlideArticles);
$(document).on('shopify:section:load', SlideArticles);

function SlideArticles() {

    // $('.blogs-slider').slick({
    //     dots: true,
    //     infinite: true,
    //     speed: 1000,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     responsive: [
    //         {
    //             breakpoint: 1174,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 arrows: false
    //             }
    //         }
    //     ]
    // });
}

/*===============================================
* product-recommendations.js
* ================================================*/
//Slider for related products

$(document).on('shopify:section:select', SliderRelatedProducts);
$(document).on('shopify:section:load', SliderRelatedProducts);

function SliderRelatedProducts() {
    // $('.product-recommendations_slider').slick({
    //     dots: false,
    //     infinite: true,
    //     speed: 1000,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     responsive: [
    //         {
    //             breakpoint: 1174,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll:1
    //             }
    //         },
    //         {
    //             breakpoint: 966,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         },
    //         {
    //             breakpoint: 550,
    //             settings: {
    //                 slidesToShow: 1
    //             }
    //         }
    //     ]
    // });
}


/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }
        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();


/*===============================================
* Launch after document ready *
* ================================================*/
/* Regions data from App*/

$.getJSON('/apps/' + window.theme.kitchenCentreKey + '/getDeliveryRegions', function (data) {
  
    if (data) {
        slate.subscriptions.singleSubscription(data, window.theme.kitchenCentreKey);
        if ($('body').hasClass('delivery-information')) {
            mainDeliveryMap(data);
        }

        if (window.theme.cartType == 'drawer') {
            cartDrawerDelivery(data);
            forCheckSavedInfo(data);
            drawerButtonCheckout(data);
        } else {
            slate.cart.cartDelivery(data);
        }
    }
});

/*===============================================
* End - Launch after document ready *
* ================================================*/


/**
 * Dropdown on mega menu hover
 * ------------------------------------------------------------------------------
 * This invokes dropdown in the mega menu upon hovering a link with submenu
 * for desktop and mobile.
 *
 */

const megaMenu = document.querySelectorAll('.mega-menu');

megaMenu.forEach( mega => {

    function showHide(evt) {
        let nodeName = evt.toElement.nodeName;
        let timeOutHandle = null;    
        if ( nodeName.trim() === 'DETAILS' || nodeName.trim() === 'HEADER') {
            if (timeOutHandle !== null) {
                clearTimeout(timeOutHandle);
                timeOutHandle = null;
            }
            mega.setAttribute('open', true);
        } else {
            if (evt.toElement.id !== 'Details-HeaderMenu-3') {
                mega.removeAttribute('open');
            } else {
                timeOutHandle = setTimeout( function() {
                    mega.removeAttribute('open');
                }, 1000 );
            }
        }
    }

    mega.addEventListener('mouseenter', (event) => {
        showHide(event);
    });

    mega.addEventListener('mouseleave', (event) => {
        showHide(event);
    });

})